export default {
  "nav_signin": "Accedi",
  "nav_account": "Account",
  "nav_signout": "Esci",
  "hero_title": "Soluzioni Digitali Intelligenti",
  "hero_title_line1": "Infinity Business — Soluzioni",
  "hero_title_line2": "Digitali Intelligenti",
  "hero_subtitle": "Incontra RisTA, il tuo partner digitale intelligente",
  "hero_cta": "Parla con RisTA",
  "hero_cta2": "Vedi i servizi",
  "b2b_title": "Soluzioni Aziendali (B2B)",
  "p2p_title": "Soluzioni Personali (P2P)",
  "b2b_desc": "Web, mobile, software, hosting, design e pubblicità",
  "p2p_desc": "Educazione crypto, strumenti di investimento, organizzazione, traduzione, branding, domini",
  "services_title": "I Nostri Servizi",
  "services_subtitle": "Dalle soluzioni web agli strumenti di investimento. RisTA vi guida.",
  "cta_title": "Pronti a creare qualcosa di straordinario?",
  "cta_subtitle": "Parla con RisTA per un preventivo personalizzato.",
  "about": "Chi siamo",
  "contact": "Contatti",
  "privacy": "Privacy",
  "blog": "Blog",
  "donate": "Dona",
  "booking": "Prenota una sessione",
  "login_title": "Bentornato",
  "register_title": "Crea un account",
  "login_subtitle": "Accedi al tuo account Infinity Business",
  "register_subtitle": "Unisciti a Infinity Business oggi",
  "auth0_btn": "Continua con Auth0",
  "or_email": "o continua con email",
  "email": "Indirizzo e-mail",
  "password": "Password",
  "full_name": "Nome completo",
  "signin_btn": "Accedi",
  "register_btn": "Crea account",
  "no_account": "Non hai un account?",
  "have_account": "Hai già un account?",
  "create_one": "Creane uno",
  "sign_in": "Accedi",
  "pricing_title": "Scegli il tuo piano",
  "pricing_subtitle": "Fai crescere la tua attività. Tutti i piani includono RisTA.",
  "pay_stripe": "Paga con Stripe",
  "pay_mypos": "Paga con myPOS",
  "pay_crypto": "Paga con Crypto",
  "free_plan": "Piano gratuito attuale",
  "most_popular": "Più popolare",
  "dashboard_title": "Il mio account",
  "profile": "Profilo",
  "security": "Sicurezza (2FA)",
  "subscription": "Abbonamento",
  "upgrade": "Aggiorna",
  "change_plan": "Cambia piano",
  "twofa_title": "Autenticazione a due fattori",
  "setup_2fa": "Configura 2FA",
  "disable_2fa": "Disattiva 2FA",
  "payment_success": "Pagamento riuscito!",
  "payment_cancel": "Pagamento annullato",
  "footer_copyright": "© 2026 Liber Nostra d.o.o. Tutti i diritti riservati.",
  "about_title": "Chi Siamo - Infinity Business",
  "contact_title": "Contattaci",
  "privacy_title": "Informativa sulla privacy",
  "send_message": "Invia messaggio",
  "trade_title": "Facciamo trading per te",
  "trade_desc": "Servizi professionali di crypto trading. Contattaci e prenota una sessione.",
  "back_home": "Torna alla home",
  "loading": "Caricamento...",
  "save": "Salva",
  "session_expired": "La sessione è scaduta. Effettua nuovamente l'accesso.",
  "nav_services": "Servizi",
  "nav_portal": "Portale",
  "nav_credits": "Crediti",
  "hero_online": "Online",
  "hero_digital_partner": "Partner digitale",
  "business_solutions": "Soluzioni aziendali",
  "personal_solutions": "Soluzioni personali",
  "enterprise_desc": "Servizi digitali professionali per la crescita del tuo business.",
  "personal_desc": "Strumenti di investimento e formazione per la crescita personale.",
  "services_hero_title": "I nostri servizi",
  "services_hero_desc": "Dai siti web alle soluzioni intelligente avanzate. Offriamo eccellenza digitale.",
  "get_started": "Inizia",
  "get_a_quote": "Richiedi preventivo",
  "free_seo_audit": "Audit SEO gratuito",
  "ready_to_start": "Pronto per iniziare?",
  "ready_to_build": "Pronto a creare qualcosa di straordinario?",
  "ready_to_build_sub": "Parla con RisTA per un preventivo personalizzato.",
  "trusted_worldwide": "Fiducia mondiale",
  "chat_placeholder": "Scrivi il tuo messaggio...",
  "chat_suggested_1": "Ho bisogno di un sito web",
  "chat_suggested_2": "Parlami dei servizi",
  "chat_suggested_3": "Voglio un servizio intelligente",
  "chat_suggested_4": "Ottenere un preventivo",
  "trust_platform": "Piattaforma affidabile",
  "trust_security": "Sicurezza aziendale",
  "trust_ai": "Tecnologia Intelligente",
  "trust_global": "Portata globale",
  "back_to_home": "Torna alla home",
  "continue_google": "Continua con Google",
  "continue_facebook": "Continua con Facebook",
  "continue_github": "Continua con GitHub",
  "or_continue_email": "o continua con email",
  "two_factor_auth": "Autenticazione a due fattori",
  "enter_2fa_code": "Inserisci il codice dalla tua app di autenticazione",
  "verify_btn": "Verifica codice",
  "verifying": "Verifica in corso...",
  "use_different_account": "Usa un altro account",
  "session_expired_msg": "La sessione è scaduta per inattività.",
  "nav_home": "Home",
  "nav_back": "Indietro",
  "my_account": "Il mio account",
  "sign_out": "Esci",
  "client_portal": "Portale clienti",
  "your_projects": "I tuoi progetti",
  "your_invoices": "Le tue fatture",
  "projects": "Progetti",
  "invoices_tab": "Fatture",
  "milestones": "Traguardi",
  "messages": "Messaggi",
  "no_projects": "Nessun progetto ancora.",
  "no_invoices": "Nessuna fattura ancora.",
  "no_messages": "Nessun messaggio ancora.",
  "type_message": "Scrivi un messaggio...",
  "back_to_projects": "Torna ai progetti",
  "budget_label": "Budget",
  "progress_label": "Progresso",
  "service_label": "Servizio",
  "portal_locked_desc": "Il portale è disponibile per i clienti approvati.",
  "contact_to_start": "Contattaci per iniziare",
  "quick_web_dev": "Sviluppo web",
  "quick_mobile": "App mobile",
  "quick_crypto": "Educazione crypto",
  "quick_get_quote": "Richiedi preventivo",
  "quick_tell_more": "Dimmi di più",
  "quick_have_project": "Ho un progetto",
  "quick_submit": "Invia richiesta",
  "get_cost_estimate": "Stima dei costi",
  "choose_plan": "Scegli il tuo piano",
  "choose_plan_desc": "Fai crescere la tua attività con il piano giusto.",
  "current_free_plan": "Piano gratuito attuale",
  "svc_ecommerce_label": "E-Commerce / Negozio Online",
  "svc_ecommerce_desc": "Negozi online completi con integrazione pagamenti",
  "svc_ecommerce_price": "Da €799",
  "svc_seo_label": "SEO e Marketing Digitale",
  "svc_seo_desc": "Ottimizzazione motori di ricerca e strategia di crescita",
  "svc_seo_price": "Da €299/mese",
  "svc_hosting_label": "Hosting Gestito",
  "svc_hosting_desc": "Infrastruttura hosting sicura, veloce e affidabile",
  "svc_hosting_price": "Da €29/mese",
  "svc_advertising_label": "Pubblicità Digitale",
  "svc_advertising_desc": "PPC, social ads e performance marketing",
  "svc_advertising_price": "Da €499/mese",
  "svc_trading_label": "Consulenza Trading",
  "svc_trading_desc": "Sessioni di strategia trading guidate da esperti",
  "svc_trading_price": "Da €149/sessione",
  "svc_domains_label": "Gestione Domini",
  "svc_domains_desc": "Registrazione domini, gestione DNS e trasferimenti",
  "svc_domains_price": "Da €19/anno",
  "testimonials_title": "Cosa dicono i nostri clienti",
  "testimonials_subtitle": "Aziende in tutta Europa si fidano di noi",
  "stat_projects": "Progetti consegnati",
  "stat_satisfaction": "Soddisfazione clienti",
  "stat_languages": "Lingue supportate",
  "all_rights_reserved": "Tutti i diritti riservati.",
  "form_your_name": "Il tuo nome",
  "form_your_email": "La tua email",
  "form_describe_need": "Descrivi le tue esigenze...",
  "form_additional_feedback": "Feedback aggiuntivo? (opzionale)",
  "form_email_followup": "La tua email (opzionale, per follow-up)",
  "form_budget_range": "Range di budget",
  "form_timeline": "Tempistica",
  "form_cancel": "Annulla",
  "form_select_services": "Seleziona i servizi (più scelte possibili):",
  "rating_title": "Valuta la tua esperienza con RisTA",
  "rating_helpful": "Quanto è stata utile questa conversazione?",
  "rating_overall": "Esperienza complessiva con l\'assistente",
  "rating_recommend": "Consiglieresti RisTA?",
  "rating_yes": "Sì",
  "rating_no": "No",
  "rating_submit": "Invia valutazione",
  "rating_skip": "Salta",
  "rating_thanks": "Grazie per il tuo feedback!",
  "generating_estimate": "Generazione preventivo...",
  "profile_info": "Informazioni profilo",
  "profile_name": "Nome",
  "profile_email": "Email",
  "profile_role": "Ruolo",
  "profile_member_since": "Membro dal",
  "profile_rerun_onboarding": "Riavvia la procedura guidata",
  "profile_language_pref": "Lingua preferita",
  "profile_language_saved": "Preferenza lingua salvata!",
  "privacy_heading": "Informativa sulla privacy",
  "terms_heading": "Termini e condizioni",
  "about_heading": "Chi Siamo - Infinity Business",
  "walkthrough_heading": "Guide",
  "estimate_title": "Preventivo del progetto",
  "estimate_service": "Servizio",
  "estimate_complexity": "Complessità",
  "estimate_base_price": "Prezzo base",
  "estimate_cost": "Costo stimato",
  "estimate_features": "Funzionalità chiave",
  "estimate_accept": "Accetta e invia",
  "estimate_revise": "Rivedi",
  "submit_service_request": "Invia la tua richiesta",
  "services_cta_title": "Pronto per iniziare?",
  "services_talk_rista": "Parla con RisTA",
  "services_free_audit": "Audit SEO gratuito",
  "nav_tools": "Strumenti",
  "nav_marketplace": "Marketplace",
  "chat_digital_partner": "Partner digitale",
  "chat_online": "Online",
  "chat_help_text": "Posso aiutare con sviluppo web, app mobile, design, crypto e altro.",
  "chat_your_partner": "Il tuo partner digitale",
  "chat_assistant_subtitle": "Chatta con il tuo assistente IA",
  "tab_password": "Password",
  "tab_rista_services": "Servizi RisTA",
  "tab_analytics": "Analisi",
  "tab_projects": "Progetti",
  "tab_referral": "Programma referral",
  "marketplace_title": "Marketplace modelli",
  "marketplace_subtitle": "Modelli premium personalizzabili. Qualità professionale, pronti all'uso.",
  "marketplace_search": "Cerca modelli...",
  "marketplace_purchase": "Acquista",
  "marketplace_preview": "Anteprima",
  "marketplace_all": "Tutti",
  "marketplace_category_website": "Sito web",
  "marketplace_category_brand": "Brand",
  "marketplace_category_resume": "CV",
  "marketplace_downloads": "download",
  "marketplace_features": "Funzionalità",
  "case_studies_title": "Storie di successo",
  "case_studies_subtitle": "Risultati reali da aziende reali. Guarda la trasformazione.",
  "case_studies_before": "Prima",
  "case_studies_after": "Dopo",
  "case_studies_cta_title": "Pronto a far crescere il tuo business?",
  "case_studies_cta_desc": "Unisciti a queste aziende e ottieni risultati simili con i nostri servizi IA.",
  "case_studies_cta_btn": "Inizia",
  "profile_go_homepage": "Vai alla homepage",
  "onboarding_welcome_title": "Benvenuto in Infinity Business",
  "onboarding_welcome_subtitle": "Il tuo partner digitale potenziato dall'IA",
  "onboarding_welcome_content": "Infinity Business offre servizi digitali B2B e P2P completi. Il nostro assistente IA RisTA ti guiderà.",
  "onboarding_welcome_item1": "Stima progetti con IA",
  "onboarding_welcome_item2": "Servizi web, mobile e design",
  "onboarding_welcome_item3": "Educazione crypto e strumenti di investimento",
  "onboarding_welcome_item4": "Consulenze personalizzate",
  "onboarding_services_title": "Esplora i nostri servizi",
  "onboarding_services_subtitle": "Due categorie su misura per te",
  "onboarding_services_content": "Offriamo due categorie di servizi:",
  "onboarding_services_item1": "B2B: Sviluppo web, app mobile, design grafico, hosting, software, pubblicità",
  "onboarding_services_item2": "P2P: Educazione crypto, strumenti di investimento, trading, domini, DeFi",
  "onboarding_services_item3": "Servizi IA: CV, business plan, report SEO, kit brand e altro",
  "onboarding_services_item4": "Parla con RisTA in qualsiasi momento per un preventivo personalizzato",
  "onboarding_credits_title": "Sistema crediti",
  "onboarding_credits_subtitle": "Saldo prepagato per servizi IA",
  "onboarding_credits_content": "Usa i crediti per accesso immediato ai nostri servizi IA:",
  "onboarding_credits_item1": "Ricarica il tuo saldo in qualsiasi momento (min. 5, max. 1.000)",
  "onboarding_credits_item2": "I crediti vengono detratti automaticamente quando usi servizi IA",
  "onboarding_credits_item3": "Ti verrà sempre chiesto di confermare prima di ogni detrazione",
  "onboarding_credits_item4": "Visualizza il tuo saldo e la cronologia nel pannello crediti",
  "onboarding_chat_title": "Parla con RisTA",
  "onboarding_chat_subtitle": "Il tuo partner digitale è pronto",
  "onboarding_chat_content": "RisTA può aiutarti con:",
  "onboarding_chat_item1": "Ottenere stime e preventivi di progetto",
  "onboarding_chat_item2": "Esplorare le opzioni di servizio in dettaglio",
  "onboarding_chat_item3": "Inviare richieste di servizio",
  "onboarding_chat_item4": "Rispondere a domande in 11 lingue",
  "onboarding_next": "Avanti",
  "onboarding_get_started": "Inizia",
  "onboarding_back": "Indietro",
  "onboarding_biz_title": "Selezione servizi",
  "onboarding_biz_subtitle": "Cosa descrive meglio le tue esigenze?",
  "onboarding_biz_content": "Aiutaci a consigliarti i servizi giusti:",
  "onboarding_biz_type_startup": "Startup / Nuova attività",
  "onboarding_biz_type_smb": "Piccola-Media impresa",
  "onboarding_biz_type_enterprise": "Grande impresa / Corporazione",
  "onboarding_biz_type_freelancer": "Freelancer / Individuale",
  "onboarding_biz_type_investor": "Investitore / Appassionato crypto",
  "change_password_title": "Cambia password",
  "referral_title": "Programma referral",
  "referral_generate": "Genera il mio codice referral",
  "referral_redeem_title": "Riscatta un codice",
  "referral_redeem_btn": "Riscatta",
  "referral_referrals": "Referral",
  "referral_rewards": "Ricompense",
  "referral_copy_link": "Copia link",
  "referral_copied": "Copiato!",
  "project_tracker_title": "Tracker progetti",
  "project_no_projects": "Ancora nessun progetto. I progetti appariranno qui dopo l'acquisto di un servizio.",
  "analytics_total_services": "Servizi totali",
  "analytics_completed": "Completati",
  "analytics_pending": "In attesa",
  "analytics_total_spent": "Totale speso",
  "analytics_credit_balance": "Saldo crediti",
  "analytics_recent": "Servizi recenti",
  "nav_try_free": "Prova gratis",
  "testimonial_1_text": "RisTA ci ha aiutato a costruire tutta la nostra presenza web in sole 2 settimane.",
  "testimonial_2_text": "Il kit del brand e il calendario social ci hanno fatto risparmiare mesi di lavoro.",
  "testimonial_3_text": "Uso regolarmente il creatore di CV e gli strumenti di analisi. La qualità IA è eccellente.",
  "services_cta_desc": "Parla con RisTA, il nostro assistente digitale intelligente, per ottenere un preventivo personalizzato.",
  "tools_title": "Strumenti di marketing gratuiti",
  "tools_subtitle": "Prova i nostri strumenti gratuiti - senza registrazione",
  "sp_basic_web_name": "Creazione sito web base",
  "sp_basic_web_desc": "Sito web professionale per la tua attivita con design moderno e piena compatibilita mobile.",
  "sp_basic_web_feat": "Design responsive moderno|Fino a 5 pagine|Integrazione modulo contatto|Ottimizzato per mobile|Setup SEO base|Assistenza inserimento contenuti",
  "sp_web_store_name": "Negozio online / E-Commerce",
  "sp_web_store_desc": "Piattaforma e-commerce completa con pagamenti integrati e strumenti di marketing.",
  "sp_web_store_feat": "Negozio online completo|Elaborazione pagamenti|Gestione prodotti|Tracciamento ordini|Ottimizzazione SEO|Strategia marketing inclusa",
  "sp_custom_web_name": "Applicazione web personalizzata",
  "sp_custom_web_desc": "Applicazioni web su misura per le tue esigenze aziendali.",
  "sp_custom_web_feat": "Design software personalizzato|Integrazioni API|Architettura database|Infrastruttura scalabile|Dashboard admin|Supporto continuo",
  "sp_mobile_app_name": "Applicazione mobile",
  "sp_mobile_app_desc": "Applicazioni mobile native e cross-platform per iOS e Android.",
  "sp_mobile_app_feat": "iOS e Android|Sviluppo cross-platform|Notifiche push|Pubblicazione su app store|Design UI/UX|Integrazione backend",
  "sp_seo_name": "SEO e marketing digitale",
  "sp_seo_desc": "Aumenta la tua visibilita online con strategie SEO e marketing digitale complete.",
  "sp_seo_feat": "Audit SEO completo|Ottimizzazione parole chiave|Strategia contenuti|Gestione Google Ads|Marketing social media|Report mensili",
  "sp_graphic_name": "Design grafico e branding",
  "sp_graphic_desc": "Soluzioni complete di branding e design grafico per la tua identita aziendale.",
  "sp_graphic_feat": "Design logo|Identita del brand|Materiali marketing|Grafiche social media|Design stampa|Guida di stile",
  "sp_crypto_edu_name": "Programma educazione crypto",
  "sp_crypto_edu_desc": "Impara il trading di criptovalute e la tecnologia blockchain dagli esperti.",
  "sp_crypto_edu_feat": "Fondamenti blockchain|Strategie di trading|Sicurezza wallet|Introduzione DeFi|Analisi di mercato|Mentoring personale",
  "sp_invest_name": "Strumenti di investimento intelligenti",
  "sp_invest_desc": "Strumenti professionali di tracciamento e analisi investimenti con IA.",
  "sp_invest_feat": "Tracker portafoglio|Dashboard mercato|Analisi IA|Valutazione rischi|Avvisi in tempo reale|Supporto multi-exchange",
  "sp_ad_name": "Servizi pubblicitari",
  "sp_ad_desc": "Raggiungi milioni attraverso la nostra vasta rete di portali in piu regioni.",
  "sp_ad_feat": "Rete 20+ portali|10M+ di portata|Campagne mirate|Tracciamento performance|Annunci multi-piattaforma|Ottimizzazione ROI",
  "contact_heading": "Contattaci",
  "contact_subtitle_text": "Hai una domanda o vuoi discutere un progetto? Saremo felici di sentirti.",
  "contact_name_label": "Nome",
  "contact_email_label": "Email",
  "contact_subject_label": "Oggetto",
  "contact_message_label": "Messaggio",
  "contact_name_ph": "Il tuo nome",
  "contact_email_ph": "tu@esempio.com",
  "contact_subject_ph": "Di cosa si tratta?",
  "contact_message_ph": "Raccontaci del tuo progetto o domanda...",
  "contact_send_btn": "Invia messaggio",
  "contact_sending": "Invio in corso...",
  "contact_sent_title": "Messaggio inviato!",
  "contact_sent_msg": "Grazie per averci contattato. Ti risponderemo entro 24 ore.",
  "contact_send_another": "Invia un altro messaggio",
  "contact_info_email": "Email",
  "contact_info_location": "Posizione",
  "contact_info_eu": "Unione Europea",
  "contact_info_response": "Tempo di risposta",
  "contact_info_response_time": "Entro 24 ore",
  "contact_info_hours": "Lun - Ven, 9:00 - 18:00 CET",
  "tf_seo_name": "Audit SEO gratuito",
  "tf_seo_desc": "Ottieni un'analisi SEO completa di qualsiasi sito - senza registrazione.",
  "tf_color_name": "Generatore palette colori",
  "tf_color_desc": "Genera palette di colori belle e armoniose per il tuo brand.",
  "tf_headline_name": "Analizzatore titoli",
  "tf_headline_desc": "Valuta i tuoi titoli per potenziale di click e impatto emotivo.",
  "tf_chat_name": "Chatta con RisTA",
  "tf_chat_desc": "Ottieni stime di progetto istantanee ed esplora i servizi in 11 lingue.",
  "tf_free_label": "Gratuito",
  "tools_seo_title": "Controllo SEO rapido",
  "tools_seo_desc": "Punteggio SEO istantaneo per qualsiasi sito",
  "tools_seo_ph": "Inserisci URL del sito (es. esempio.com)",
  "tools_analyze": "Analizza",
  "tools_color_title": "Generatore palette colori",
  "tools_color_desc": "Genera palette di colori complementari",
  "tools_headline_title": "Analizzatore titoli",
  "tools_headline_desc": "Analizza l'efficacia dei titoli",
  "tools_headline_ph": "Inserisci il tuo titolo...",
  "tools_headline_btn": "Analizza titolo",
  "tools_issues": "Problemi trovati",
  "tools_suggestions": "Suggerimenti",
  "tools_score": "Punteggio",
  "docs_heading": "Funzionalita della piattaforma",
  "docs_subtitle": "Tutto cio che Infinity Business offre per il tuo percorso digitale.",
  "docs_no_data": "Nessuna documentazione disponibile.",
  "tester_heading": "Diventa tester",
  "tester_subtitle": "Aiutaci a migliorare la piattaforma e ottieni accesso gratuito ai servizi.",
  "tester_req_title": "Cosa e richiesto",
  "tester_req_1": "Accedi almeno 5 volte a settimana",
  "tester_req_2": "Invia almeno 10 segnalazioni bug/feedback a settimana",
  "tester_req_3": "Testa diverse funzionalita, pagine e flussi utente",
  "tester_benefit_title": "Cosa ottieni",
  "tester_benefit_1": "Accesso gratuito ai servizi del sistema intelligente (su richiesta)",
  "tester_benefit_2": "Dashboard tester con tracciamento progressi",
  "tester_benefit_3": "Supporto prioritario dal team",
  "tester_apply_title": "Candidati",
  "tester_motivation": "Perche vuoi essere un tester?",
  "tester_motivation_ph": "Dicci perche vorresti aiutare a testare la piattaforma...",
  "tester_experience": "Esperienza di test (opzionale)",
  "tester_experience_ph": "Qualsiasi esperienza rilevante...",
  "tester_submit_app": "Invia candidatura",
  "tester_applied_title": "Candidatura inviata",
  "tester_applied_msg": "Il nostro admin esaminer la tua candidatura e sarai notificato.",
  "tester_need_account": "Hai bisogno di un account per candidarti.",
  "tester_dash_title": "Dashboard tester",
  "tester_dash_desc": "Mantieni il tuo stato di tester attivo raggiungendo gli obiettivi settimanali.",
  "tester_weekly_logins": "Accessi settimanali",
  "tester_weekly_reports": "Report settimanali",
  "tester_target_met": "Obiettivo raggiunto!",
  "tester_logins_needed": "accessi ancora necessari questa settimana",
  "tester_reports_needed": "report ancora necessari questa settimana",
  "tester_total_reports": "Totale report inviati",
  "tester_on_track": "In linea",
  "tester_at_risk": "A rischio",
  "tester_report_heading": "Invia segnalazione bug / feedback",
  "tester_report_title_ph": "Titolo (es. 'Pulsante non cliccabile su mobile')",
  "tester_report_desc_ph": "Descrivi il problema o il suggerimento in dettaglio...",
  "tester_report_page_ph": "URL della pagina (opzionale)",
  "tester_submit_report": "Invia segnalazione",
  "seo_page_title": "Audit SEO gratuito",
  "seo_page_desc": "Inserisci qualsiasi URL per un'analisi SEO completa con raccomandazioni.",
  "seo_page_ph": "Inserisci URL del sito (es. esempio.com)",
  "seo_page_btn": "Esegui audit",
  "seo_page_running": "Analisi in corso...",
  "seo_page_error": "Impossibile analizzare questo sito. Controlla l'URL e riprova.",
  "referral_reward_title": "Come funzionano le ricompense",
  "referral_reward_desc": "Guadagna il 10% di ogni acquisto effettuato dagli utenti che inviti, accreditato automaticamente come crediti gratuiti.",
  "referral_reward_1": "Condividi il tuo link di riferimento unico con gli amici",
  "referral_reward_2": "Quando effettuano un acquisto, guadagni il 10% come crediti gratuiti",
  "referral_reward_3": "I crediti vengono aggiunti automaticamente al tuo saldo",
  "referral_earned_label": "Crediti guadagnati",
  "profile_picture": "Foto profilo",
  "profile_bio": "Biografia",
  "profile_website": "Sito web",
  "profile_interests": "Interessi",
  "profile_upload_photo": "Carica foto",
  "profile_bio_ph": "Parlaci di te...",
  "profile_website_ph": "https://tuosito.com",
  "profile_interests_ph": "es. Sviluppo web, Crypto, IA",
  "profile_save": "Salva profilo",
  "admin_notes": "Note admin",
  "admin_notes_ph": "Aggiungi nota su questo utente...",
  "admin_notes_add": "Aggiungi nota",
  "sub_most_popular": "Più popolare",
  "sub_free": "Gratuito",
  "sub_one_time": "pagamento unico",
  "sub_team_members": "Membri del team",
  "sub_members_info": "Invita i membri del team a condividere il tuo piano. Ogni membro ottiene il proprio accesso ai servizi sotto il tuo abbonamento.",
  "sub_show_less": "Mostra meno",
  "sub_more_features": "altre funzionalità",
  "sub_pay_with": "Paga con",
  "sub_preferred": "preferito",
  "sub_live_crypto": "Prezzi crypto in diretta (EUR e USD)",
  "sp_logo_name": "Design del Logo",
  "sp_logo_desc": "Design del logo professionale che cattura l'essenza del tuo brand.",
  "sp_logo_feat": "3 concetti unici|Revisioni illimitate|File vettoriali|Colore + B/N|Linee guida brand|Kit social media",
  "sp_brand_name": "Identità del Brand Completa",
  "sp_brand_desc": "Pacchetto completo di identità del brand con logo, palette e linee guida.",
  "sp_brand_feat": "Logo|Palette colori|Tipografia|Biglietto da visita|Carta intestata|PDF linee guida|Template social",
  "sp_poster_name": "Design Poster",
  "sp_poster_desc": "Design poster accattivanti per eventi e campagne pubblicitarie.",
  "sp_poster_feat": "Illustrazione personalizzata|File pronti per la stampa|Diverse dimensioni|2 giri di revisione|Alta risoluzione|Digitale + stampa",
  "sp_flyer_name": "Design Volantino",
  "sp_flyer_desc": "Design volantini professionali per marketing ed eventi.",
  "sp_flyer_feat": "Fronte e retro|PDF per stampa|Versione digitale|Codice QR|2 revisioni|Diversi formati",
  "sp_menu_name": "Design Menù",
  "sp_menu_desc": "Bellissimi design di menù per ristoranti e caffè.",
  "sp_menu_feat": "Layout personalizzato|Integrazione foto|Versione QR|File per stampa|Aggiornamento stagionale|Più pagine",
  "currency_label": "Valuta",
  "currency_eur": "EUR",
  "currency_usd": "USD",
  "currency_cny": "CNY",
  "about_intro": "Siamo un'azienda tecnologica focalizzata su soluzioni digitali intelligenti. Fondata nel 2026, Infinity Business unisce innovazione intelligente e competenza comprovata.",
  "about_values": "I Nostri Valori",
  "about_what_we_do": "Cosa Facciamo",
  "about_meet_rista": "Incontra RisTA",
  "about_rista_desc": "RisTA è il nostro assistente intelligente intelligente. Aiuta a qualificare i requisiti, offre guida istantanea e ti connette con il nostro team. Disponibile 24/7, multilingue.",
  "about_talk_rista": "Parla con RisTA",
  "about_val_trust": "Fiducia e Sicurezza",
  "about_val_trust_desc": "Applichiamo i più alti standard di protezione dei dati.",
  "about_val_innovation": "Innovazione",
  "about_val_innovation_desc": "Tecnologia intelligente all'avanguardia alimenta le nostre soluzioni.",
  "about_val_partnership": "Partnership",
  "about_val_partnership_desc": "Lavoriamo al tuo fianco come vero partner.",
  "about_val_global": "Portata Globale",
  "about_val_global_desc": "Le nostre soluzioni sono progettate per i mercati internazionali.",
  "about_svc_web": "Sviluppo Web",
  "about_svc_web_desc": "Applicazioni web, piattaforme e-commerce e soluzioni CMS.",
  "about_svc_mobile": "Applicazioni Mobile",
  "about_svc_mobile_desc": "App native e cross-platform per iOS e Android.",
  "about_svc_software": "Software Personalizzato",
  "about_svc_software_desc": "Soluzioni software su misura per automatizzare i processi aziendali.",
  "about_svc_invest": "Investimenti Intelligenti",
  "about_svc_invest_desc": "Strumenti crypto e DeFi con intelligente e servizi di trading professionali.",
  "micro_tools_title": "Micro-strumenti intelligenti",
  "micro_tools_subtitle": "Informazioni istantanee basate sull'IA per generazione lead e pianificazione strategica.",
  "micro_tools_all": "Tutti",
  "micro_tools_try": "Prova",
  "micro_tools_generate_free": "Genera (Gratis)",
  "micro_tools_generate_paid": "Genera",
  "micro_tools_close": "Chiudi",
  "micro_tools_interested": "Interessato?",
  "tools_view_service": "Vedi servizio",
  "tools_talk_rista": "Parla con RisTA",
  "competitor_title": "Analisi della concorrenza IA",
  "competitor_desc": "Inserisci l'URL del competitor per un'analisi IA con confronto SEO e valutazione del design.",
  "competitor_url_ph": "Inserisci URL del competitor",
  "competitor_analyze": "Analizza competitor",
  "competitor_score": "Punteggio complessivo",
  "competitor_seo": "Analisi SEO",
  "competitor_design": "Analisi del design",
  "competitor_content": "Analisi dei contenuti",
  "competitor_strengths": "Punti di forza",
  "competitor_weaknesses": "Punti deboli",
  "competitor_opportunities": "Opportunità",
  "competitor_recommendations": "Raccomandazioni",
  "accessibility_title": "Controllo accessibilità",
  "accessibility_desc": "Verifica la conformità agli standard di accessibilità",
  "cat_lead_gen": "Lead-Gen e traffico",
  "cat_discovery": "Scoperta report",
  "cat_email": "Email e workflow",
  "cat_planning": "Pianificazione e strategia",
  "cat_content": "Contenuti e posizionamento",
  "sp_tools_title": "Micro-servizi Intelligenti",
  "sp_tools_desc": "Servizi intelligenti istantanei per contenuti, branding, analisi e documenti.",
  "sp_free_title": "Strumenti Gratuiti",
  "sp_free_desc": "Prova la nostra piattaforma con questi strumenti gratuiti.",
  "a11y_checker": "Verifica accessibilità",
  "a11y_compliant": "Conforme",
  "a11y_disclaimer": "I controlli automatici coprono ~30% dei problemi di accessibilità. Si consigliano test manuali.",
  "a11y_error": "Audit fallito. Riprovare.",
  "a11y_incomplete": "necessita revisione",
  "a11y_issues_found": "Problemi trovati",
  "a11y_no_issues": "Nessun problema di accessibilità trovato!",
  "a11y_passed": "superato",
  "a11y_rescan": "Riscansiona",
  "a11y_scanning": "Esecuzione audit WCAG...",
  "a11y_violations": "violazioni",
  "admin_ab_testing": "Test A/B",
  "admin_account_mgmt": "Gestione account",
  "admin_actions": "Azioni",
  "admin_active": "Attivo",
  "admin_ad_gen": "Generatore annunci",
  "admin_add_milestone": "Aggiungi traguardo",
  "admin_adv_reports": "Report avanzati",
  "admin_ai_config": "Configurazione modello",
  "admin_ai_prompts": "Prompt intelligenti",
  "admin_analytics": "Analitica",
  "admin_audit": "Audit piattaforma",
  "admin_audit_trail": "Registro audit",
  "admin_auto_posting": "Pubblicazione automatica intelligente",
  "admin_avatar_builder": "Costruttore avatar",
  "admin_avatar_selector": "Selettore avatar",
  "admin_avg_exp": "Esp. media",
  "admin_avg_rating": "Valutazione media",
  "admin_backup": "Backup e ripristino",
  "admin_billing": "Fatturazione ricorrente",
  "admin_blog": "Gestore blog",
  "admin_bug_reports": "Segnalazioni bug",
  "admin_cancel": "Annulla",
  "admin_cdn": "Gestore CDN",
  "admin_chat_analytics": "Analitica chat",
  "admin_chat_sessions": "Sessioni chat",
  "admin_client_portal": "Portale clienti",
  "admin_abandoned_carts": "Carrelli abbandonati",
  "rista_login_required": "Accesso richiesto",
  "rista_login_desc": "Accedi o crea un account per chattare con RisTA e ricevere raccomandazioni aziendali personalizzate.",
  "rista_login_btn": "Accedi",
  "rista_signup_btn": "Registrati",
  "admin_created": "Creato",
  "admin_credits": "Configurazione crediti",
  "admin_crypto_payments": "Pagamenti crypto",
  "admin_crypto_trading": "Trading crypto",
  "admin_currency": "Multi-valuta",
  "admin_defi": "Elementi DeFi",
  "admin_delete": "Elimina",
  "admin_demo": "Accesso demo",
  "admin_demo_banner": "MODALITÀ SOLA LETTURA - Account demo (Tutti i dati sono mascherati)",
  "admin_docs": "Documentazione",
  "admin_domain": "Gestore domini",
  "admin_edit": "Modifica",
  "admin_email_builder": "Costruttore email",
  "admin_email_templates": "Modelli email",
  "admin_email_templates_desc": "Personalizza i modelli email con l'editor visuale a blocchi.",
  "admin_escalations": "Escalation chat",
  "admin_fb": "Analitica FB",
  "admin_followups": "Email di follow-up",
  "admin_health": "Monitor salute",
  "admin_health_monitor": "Monitoraggio salute",
  "admin_health_score": "Punteggio salute",
  "admin_high_leads": "Lead prioritari",
  "admin_high_value": "Lead ad alto valore",
  "admin_image_gen": "Generazione immagini",
  "admin_integrations": "Integrazioni",
  "admin_invoices": "Fatturazione",
  "admin_kb": "Base di conoscenza",
  "admin_language_requests": "Richieste lingue",
  "admin_lead_tracking": "Tracciamento lead",
  "admin_live_analytics": "Analitica dal vivo",
  "admin_loading": "Caricamento...",
  "admin_logo": "Logo e favicon",
  "admin_milestone_desc": "Descrizione (opzionale)",
  "admin_milestone_title": "Titolo traguardo",
  "admin_my_account": "Il mio account",
  "admin_new": "nuovo",
  "admin_no_data": "Nessun dato disponibile",
  "admin_no_matching": "Nessuna scheda corrispondente",
  "admin_no_milestones": "Nessun traguardo ancora. Aggiungi il primo!",
  "admin_notifications": "Notifiche",
  "admin_out_of": "Di",
  "admin_overview": "Panoramica",
  "admin_panel": "Pannello di amministrazione",
  "admin_payment_opts": "Opzioni di pagamento",
  "admin_pending": "In attesa",
  "admin_portfolio": "Gestore portfolio",
  "admin_preloader": "Configurazione preloader",
  "admin_pricing": "Prezzi dinamici",
  "admin_promo": "Codici promozionali",
  "admin_rate_limiting": "Limitazione velocità",
  "admin_rbac": "Controllo accessi",
  "admin_referral_board": "Classifica referral",
  "admin_referrals": "Programma referral",
  "admin_reports": "Report admin",
  "admin_requests": "Richieste di servizio",
  "admin_reviews": "recensioni",
  "admin_rista": "Servizi RisTA",
  "admin_save": "Salva",
  "admin_score": "Punteggio",
  "admin_search_tabs": "Cerca schede...",
  "admin_sendgrid": "Email (SendGrid)",
  "admin_service_mgr": "Gestore servizi",
  "admin_sign_out": "Disconnetti",
  "admin_social": "Social media",
  "admin_social_auto": "Automazione social",
  "admin_social_icons": "Icone social",
  "admin_status": "Stato",
  "admin_surveys": "Sondaggi soddisfazione",
  "admin_system_admin": "AMMINISTRATORE DI SISTEMA",
  "admin_system_config": "Configurazione sistema",
  "admin_tester": "Programma tester",
  "admin_timeline": "Timeline progetto",
  "admin_total": "Totale",
  "admin_ui_toggles": "Toggle UI",
  "admin_unread": "Non letto",
  "admin_updated": "Aggiornato",
  "admin_users": "Gestione utenti",
  "admin_view_all": "Vedi tutto",
  "billing_cancel_btn": "Annulla piano",
  "billing_manage_btn": "Gestisci fatturazione",
  "billing_manage_desc": "Gestisci metodi di pagamento, visualizza fatture o aggiorna i dati di fatturazione tramite il portale Stripe.",
  "billing_management": "Gestione fatturazione",
  "change_password_btn": "Cambia password",
  "change_password_confirm": "Conferma nuova password",
  "change_password_current": "Password attuale",
  "change_password_new": "Nuova password",
  "change_password_social": "Il cambio password non è disponibile per gli account con login social.",
  "health_a11y": "Accessibilità",
  "health_desc": "Analisi completa di SEO, prestazioni, sicurezza e accessibilità del tuo sito web.",
  "health_history": "Cronologia scansioni",
  "health_login_desc": "Crea un account gratuito per scansionare il tuo sito e monitorare i miglioramenti.",
  "health_login_required": "Accedi per usare il punteggio salute",
  "health_overall": "Punteggio salute complessivo",
  "health_perf": "Prestazioni",
  "health_premium_badge": "Funzionalità Premium",
  "health_response": "Risposta",
  "health_scan_btn": "Scansiona",
  "health_scan_error": "Scansione fallita. Verifica l'URL.",
  "health_scanning": "Scansione...",
  "health_security": "Sicurezza",
  "health_seo": "SEO",
  "health_size": "Dimensione",
  "health_title": "Punteggio salute del sito web",
  "health_upgrade_btn": "Passa a Premium",
  "health_upsell_desc": "Passa a Premium per scansioni automatiche settimanali, avvisi email e monitoraggio tendenze.",
  "health_upsell_title": "Monitoraggio ricorrente desiderato?",
  "health_url_ph": "Inserisci URL del sito (es: example.com)",
  "nav_currency": "Valuta",
  "nav_health_score": "Punteggio salute",
  "nav_orders": "I miei ordini",
  "plan_features": "Caratteristiche del tuo piano",
  "priority_critical": "Critica",
  "priority_high": "Alta",
  "priority_low": "Bassa",
  "priority_medium": "Media",
  "profile_about": "Su di te",
  "profile_appearance": "Aspetto e accessibilità",
  "profile_change_avatar": "Cambia avatar",
  "profile_country": "Paese",
  "profile_country_ph": "es: Italia, Germania, Svizzera",
  "profile_interests_hint": "Separa gli interessi con virgole",
  "profile_text_size": "Dimensione testo",
  "profile_text_size_hint": "Regola la dimensione del testo per una migliore leggibilità.",
  "profile_theme": "Tema",
  "seo_cta_desc": "Il nostro audit SEO intelligente copre 100+ punti di controllo. Ottieni aiuto professionale.",
  "seo_cta_title": "Hai bisogno di aiuto con questi problemi?",
  "sp_biz_plan_desc": "Genera un business plan completo con finanze, analisi di mercato e strategia di crescita.",
  "sp_biz_plan_feat": "Sommario esecutivo|Analisi di mercato|Proiezioni finanziarie|Panoramica competitiva|Strategia di crescita|Formato investitore",
  "sp_biz_plan_name": "Business plan intelligente",
  "sp_brand_kit_desc": "Pacchetto completo di identità di marca con concetti logo e asset social.",
  "sp_brand_kit_feat": "Concetti logo|Palette colori|Tipografia|Asset social|Linee guida brand|Set icone",
  "sp_brand_kit_name": "Logo e kit brand intelligente",
  "sp_competitor_desc": "Intelligence competitiva approfondita con confronto SEO e analisi lacune contenuto.",
  "sp_competitor_feat": "Confronto SEO|Revisione design|Lacune contenuto|Posizionamento mercato|Analisi SWOT|Raccomandazioni",
  "sp_competitor_name": "Analisi della concorrenza",
  "sp_email_campaign_desc": "Setup professionale campagne email con testo, sequenze e targeting.",
  "sp_email_campaign_feat": "Scrittura email|Setup sequenze|Targeting audience|Test A/B|Setup analytics|Design template",
  "sp_email_campaign_name": "Setup email marketing",
  "sp_free_seo_desc": "Esegui un audit SEO gratuito su qualsiasi sito web per scoprire opportunità di ottimizzazione.",
  "sp_free_seo_feat": "Risultati istantanei|100+ controlli|Punteggio prestazioni|Controllo mobile|Scansione sicurezza|Report gratuito",
  "sp_free_seo_name": "Audit SEO gratuito",
  "sp_free_tools_desc": "Accedi alla nostra collezione di strumenti gratuiti.",
  "sp_free_tools_feat": "Generatore palette|Analizzatore titoli|Generatore password|Creatore QR code|Convertitore unità|Senza registrazione",
  "sp_free_tools_name": "Strumenti digitali gratuiti",
  "sp_health_score": "Punteggio salute del sito web",
  "sp_health_score_desc": "Analisi completa del sito: SEO, prestazioni, sicurezza e accessibilità.",
  "sp_health_score_feat": "Analisi SEO|Verifica prestazioni|Scansione sicurezza|Audit accessibilità|Report dettagliato|Consigli miglioramento",
  "sp_health_score_name": "Punteggio salute del sito web",
  "sp_hosting_desc": "Infrastruttura hosting sicura, veloce e affidabile per i tuoi siti e applicazioni.",
  "sp_hosting_feat": "99.9% uptime|Certificati SSL|Backup giornalieri|Integrazione CDN|Monitoraggio 24/7|Auto-scaling",
  "sp_hosting_name": "Web hosting gestito",
  "sp_legal_docs_desc": "Template legali professionali inclusi NDA, contratti e termini di servizio.",
  "sp_legal_docs_feat": "Template NDA|Contratti di servizio|Termini di servizio|Politiche privacy|Conformità GDPR|Clausole personalizzate",
  "sp_legal_docs_name": "Generatore documenti legali",
  "sp_resume_desc": "Crea CV ottimizzati ATS adatti al tuo ruolo target e settore.",
  "sp_resume_feat": "Ottimizzazione ATS|Template per settore|Keyword matching|Lettera di presentazione|Ottimizzazione LinkedIn|Esportazione PDF",
  "sp_resume_name": "Creatore CV intelligente",
  "sp_seo_report_desc": "Analisi automatizzata del sito con raccomandazioni SEO azionabili.",
  "sp_seo_report_feat": "100+ punti controllo|Metriche prestazioni|Raccomandazioni SEO|Analisi mobile|Revisione sicurezza|Piano d'azione",
  "sp_seo_report_name": "Report audit del sito web",
  "sp_social_cal_desc": "30 giorni di contenuti social generati intelligentemente con strategia di engagement.",
  "sp_social_cal_feat": "Calendario 30 giorni|Testi post|Strategia hashtag|Consigli engagement|Migliori orari|Ottimizzazione piattaforma",
  "sp_social_cal_name": "Calendario social media",
  "sp_translation_desc": "Traduzione professionale di documenti in 50+ lingue con adattamento culturale.",
  "sp_translation_feat": "50+ lingue|Adattamento culturale|Termini tecnici|Consegna rapida|Revisione|Preservazione formato",
  "sp_translation_name": "Traduzione intelligente",
  "sp_video_script_desc": "Script video coinvolgenti per YouTube, TikTok e pubblicità ottimizzati per l'engagement.",
  "sp_video_script_feat": "Script YouTube|Contenuti TikTok|Testi pubblicitari|Ottimizzazione hook|Posizionamento CTA|Consigli engagement",
  "sp_video_script_name": "Scrittore di script video intelligente",
  "status_blocked": "Bloccato",
  "status_completed": "Completato",
  "status_in_progress": "In corso",
  "status_planned": "Pianificato",
  "admin_ratings": "Valutazioni e feedback",
  "analytics_subscription": "Abbonamento",
  "developer_title": "API Sviluppatore",
  "developer_subtitle": "Integra i nostri servizi intelligenti nelle tue applicazioni",
  "hosting_title": "Pacchetti di hosting",
  "hosting_subtitle": "Hosting affidabile e veloce per la tua azienda",
  "privacy_s1_title": "1. Informazioni che raccogliamo",
  "privacy_s2_title": "2. Come utilizziamo le informazioni",
  "privacy_s3_title": "3. Condivisione dei dati",
  "privacy_s4_title": "4. Sicurezza dei dati",
  "privacy_s5_title": "5. I vostri diritti",
  "privacy_s6_title": "6. Cookie e tracciamento",
  "privacy_s7_title": "7. Conservazione dei dati",
  "privacy_s8_title": "8. Trasferimenti internazionali",
  "privacy_s9_title": "9. Modifiche a questa politica",
  "privacy_s10_title": "10. Contattaci",
  "privacy_intro": "Infinity Business (\"noi\"), gestito da Liber Nostra d.o.o., si impegna a proteggere la vostra privacy.",
  "privacy_last_updated": "Ultimo aggiornamento: 7 marzo 2026",
  "terms_s1_title": "1. Introduzione",
  "terms_s2_title": "2. Servizi",
  "terms_s3_title": "3. Account utente",
  "terms_s4_title": "4. Pagamenti e fatturazione",
  "terms_s5_title": "5. Esclusione servizi intelligenti",
  "terms_s6_title": "6. Proprietà intellettuale",
  "terms_s7_title": "7. Privacy e dati",
  "terms_s8_title": "8. Esclusione criptovalute",
  "terms_s9_title": "9. Limitazione di responsabilità",
  "terms_s10_title": "10. Modifiche",
  "terms_s11_title": "11. Legge applicabile",
  "terms_s12_title": "12. Contatto",
  "terms_last_updated": "Ultimo aggiornamento: febbraio 2026",
  "profile_admin_dashboard": "Apri pannello admin",
  "review_title": "Cosa dicono i nostri clienti",
  "review_subtitle": "Feedback reali dalle aziende che abbiamo aiutato",
  "walkthrough_gmail": "Assistente Gmail intelligente",
  "walkthrough_gmail_desc": "Scopri come RisTA organizza la tua casella di posta",
  "walkthrough_calendar": "Consulente personale",
  "walkthrough_calendar_desc": "Calendario, attività ed email via chat",
  "walkthrough_ai": "Servizi di sistema intelligente",
  "walkthrough_ai_desc": "CV, business plan, kit brand e altro",
  "try_free_title": "Strumenti gratuiti e servizi di prova",
  "try_free_subtitle": "Nessuna carta di credito. Inizia subito a usare i nostri strumenti.",
  "try_free_section": "Completamente gratuito — nessun account necessario",
  "try_free_trial_section": "Servizi intelligenti — prova con crediti",
  "try_free_trial_desc": "Iscriviti per ottenere crediti e accedere ai servizi intelligenti.",
  "try_free_cta": "Pronto per iniziare?",
  "try_free_cta_desc": "Crea un account gratuito per i tuoi primi crediti e sblocca tutti i servizi.",
  "try_free_cta_btn": "Registrazione gratuita",
  "marketplace_close_preview": "Chiudi anteprima",
  "marketplace_live_preview": "Anteprima live",
  "testimonial_1_role": "CEO, TechStart d.o.o.",
  "testimonial_2_role": "Direttrice Marketing, BioFresh",
  "testimonial_3_role": "Sviluppatore Freelance",
  "referral_subtitle": "Invita amici e guadagna premi",
  "support_tickets": "Ticket di supporto",
  "admin_support_tickets": "Ticket di supporto",
  "admin_auto_translate": "Traduzione automatica",
  "admin_telegram": "Telegram",
  "admin_ai_prospecting": "Prospezione IA",
  "admin_project_mgmt": "Gestione progetti",
  "admin_analytics_widget": "Widget analitico",
  "admin_doc_mgmt": "Gestione documenti",
  "admin_webhooks": "Webhooks",
  "admin_white_label": "White label",
  "admin_multi_tenant": "Multi-tenant",
  "popular_services": "Servizi popolari",
  "popular_services_desc": "I più richiesti dai nostri clienti",
  "purchases": "Acquisti",
  "admin_funnel": "Funnel di conversione",
  "admin_wl_licensing": "Licenze SaaS",
  "admin_analytics_export": "Esporta analisi",
  "service_detail_features": "Cosa è incluso",
  "service_detail_related": "Servizi correlati",
  "service_detail_back": "Tutti i servizi",
  "checkout_currency": "Valuta checkout",
  "upsell_title": "Completa la configurazione",
  "upsell_desc": "Chi ha acquistato simili ha aggiunto:",
  "cart_checkout": "Checkout",
  "cart_empty": "Il carrello è vuoto",
  "push_notifications": "Notifiche push",
  "push_enabled": "Notifiche attivate",
  "push_disabled": "Attiva notifiche",
  "blog_ai_generate": "Generazione IA",
  "blog_gen_service": "Genera per servizio",
  "blog_generating": "Generazione...",
  "export_revenue": "Report entrate",
  "export_funnel": "Funnel di conversione",
  "export_users": "Elenco utenti",
  "export_pdf": "Riepilogo",
  "license_generate": "Genera licenza",
  "license_revoke": "Revoca",
  "license_renew": "Rinnova",
  "license_validate": "Convalida",
  "tier_starter": "Starter",
  "tier_professional": "Professionale",
  "tier_enterprise": "Enterprise",
  "blog_subtitle": "Approfondimenti, aggiornamenti e guide da Infinity Business.",
  "blog_search_placeholder": "Cerca articoli...",
  "blog_all": "Tutti",
  "blog_no_posts": "Nessun articolo trovato. Torna presto!",
  "blog_prev": "Precedente",
  "blog_next": "Successivo",
  "blog_back": "Torna al blog",
  "micro_tools": "Micro-strumenti intelligenti",
  "micro_tools_title": "Micro-strumenti intelligenti",
  "micro_tools_subtitle": "Micro-strumenti gratuiti basati sull'IA",
  "color_palette_title": "Generatore di palette colori",
  "color_palette_desc": "Genera belle palette di colori per il tuo brand",
  "color_palette_generate": "Genera palette",
  "color_palette_copy": "Copia",
  "color_palette_copied": "Copiato!",
  "color_palette_hex": "HEX",
  "color_palette_rgb": "RGB",
  "color_palette_hsl": "HSL",
  "color_palette_complementary": "Complementare",
  "color_palette_analogous": "Analogo",
  "color_palette_triadic": "Triadico",
  "color_palette_monochromatic": "Monocromatico",
  "admin_menu_overview": "Panoramica",
  "admin_menu_users": "Utenti",
  "admin_menu_blog": "Gestore blog",
  "admin_menu_analytics": "Analisi",
  "admin_menu_settings": "Impostazioni",
  "admin_menu_services": "Servizi",
  "admin_menu_chat": "Sessioni chat",
  "admin_menu_notifications": "Notifiche",
  "admin_menu_support": "Supporto",
  "admin_menu_security": "Sicurezza",
  "admin_menu_backup": "Backup",
  "admin_menu_revenue": "Entrate",
  "admin_menu_funnel": "Imbuto",
  "admin_menu_invoicing": "Fatturazione",
  "admin_menu_projects": "Progetti",
  "admin_menu_email": "Editor email",
  "admin_menu_ai_config": "Config. IA",
  "admin_menu_live_analytics": "Analisi in tempo reale",
  "admin_menu_platform_audit": "Audit piattaforma",
  "docs_title": "Documentazione",
  "docs_subtitle": "Scopri come utilizzare la nostra piattaforma",
  "try_free_title": "Prova gratis",
  "try_free_subtitle": "Prova i nostri servizi gratuitamente",
  "subscription_title": "Piani di abbonamento",
  "subscription_subtitle": "Scegli il piano adatto a te",
  "portfolio_title": "Portfolio",
  "portfolio_subtitle": "Il nostro lavoro parla da sé",
  "svc_web-dev_label": "Sviluppo Web",
  "svc_web-dev_desc": "Siti web, landing page e applicazioni web",
  "svc_mobile-app_label": "Sviluppo App Mobile",
  "svc_mobile-app_desc": "App iOS & Android, soluzioni multipiattaforma",
  "svc_graphic-design_label": "Design Grafico",
  "svc_graphic-design_desc": "Loghi, branding, materiali di marketing",
  "svc_custom-software_label": "Software Personalizzato",
  "svc_custom-software_desc": "Automazione aziendale su misura",
  "svc_ai-business-plan_label": "Generatore Business Plan Intelligente",
  "svc_ai-business-plan_desc": "Piano completo con finanze e analisi di mercato",
  "svc_ai-seo-report_label": "Audit Web e Report SEO",
  "svc_ai-seo-report_desc": "Analisi automatizzata con raccomandazioni",
  "svc_ai-email-campaign_label": "Setup Email Marketing",
  "svc_ai-email-campaign_desc": "L'IA scrive testi e configura sequenze email",
  "svc_ai-competitor-analysis_label": "Report Analisi Competitiva",
  "svc_ai-competitor-analysis_desc": "Intelligence di mercato e posizionamento",
  "svc_ai-legal-docs_label": "Generatore Documenti Legali",
  "svc_ai-legal-docs_desc": "NDA, contratti, modelli termini di servizio",
  "svc_crypto-education_label": "Educazione Crypto",
  "svc_crypto-education_desc": "Impara blockchain, DeFi e fondamentali crypto",
  "svc_investment-tools_label": "Strumenti di Investimento",
  "svc_investment-tools_desc": "Monitoraggio portfolio e analisi di mercato",
  "svc_defi-solutions_label": "Soluzioni DeFi",
  "svc_defi-solutions_desc": "Smart contract, yield farming",
  "svc_personal-advertising_label": "Personal Branding",
  "svc_personal-advertising_desc": "Costruisci la tua presenza online",
  "svc_ai-resume_label": "CV Builder Intelligente",
  "svc_ai-resume_desc": "CV ottimizzati ATS",
  "svc_ai-brand-kit_label": "Logo e Brand Kit Intelligente",
  "svc_ai-brand-kit_desc": "Logo, palette colori, tipografia e social asset",
  "svc_ai-social-calendar_label": "Calendario Social Media e Analisi",
  "svc_ai-social-calendar_desc": "30 giorni di post generati dall'IA",
  "svc_ai-translation_label": "Servizio di Traduzione Intelligente",
  "svc_ai-translation_desc": "Traduzione professionale in 50+ lingue",
  "svc_ai-video-script_label": "Scrittore Script Video Intelligente",
  "svc_ai-video-script_desc": "Script YouTube, TikTok e pubblicità",
  "admin_grp_dashboard": "Pannello",
  "admin_grp_users": "Utenti e accesso",
  "admin_grp_analytics": "Analisi e rapporti",
  "admin_grp_services": "Servizi e prezzi",
  "admin_grp_crypto": "Crypto e DeFi",
  "admin_grp_leads": "Lead e CRM",
  "admin_grp_content": "Contenuti",
  "admin_grp_comm": "Comunicazione",
  "admin_grp_social": "Social Media",
  "admin_grp_ai": "IA e automazione",
  "admin_grp_design": "Design e brand",
  "admin_grp_system": "Sistema",
  "admin_grp_projects": "Progetti e QA",
  "color_palette_professional": "Professionale",
  "color_palette_playful": "Giocoso",
  "color_palette_luxury": "Lusso",
  "color_palette_nature": "Natura",
  "color_palette_tech": "Tecnologia",
  "color_palette_warm": "Caldo",
  "color_palette_cool": "Freddo",
  "blog_translating": "Traduzione in corso...",
  "blog_translated_cached": "Tradotto",
  "blog_translated_fresh": "Appena tradotto",
  "blog_show_original": "Mostra originale",
  "privacy_s1_content": "Raccogliamo le informazioni che ci fornite direttamente, tra cui:\n- **Informazioni account**: Nome, e-mail e password.\n- **Richieste di servizio**: Dettagli del progetto, budget e contatti.\n- **Informazioni di pagamento**: Dati elaborati dai nostri partner (Stripe, myPOS).\n- **Dati di comunicazione**: Messaggi tramite RisTA, moduli di contatto e corrispondenza.\n- **Dati di utilizzo**: Tipo di browser, indirizzo IP, pagine visitate.",
  "privacy_s2_content": "Utilizziamo le informazioni raccolte per:\n- Fornire, mantenere e migliorare i nostri servizi\n- Elaborare transazioni\n- Inviare avvisi tecnici e supporto\n- Rispondere alle vostre domande\n- Monitorare tendenze e attività\n- Rilevare e prevenire frodi\n- Personalizzare la vostra esperienza con RisTA",
  "privacy_s3_content": "Non vendiamo i vostri dati personali. Possiamo condividere informazioni con:\n- **Fornitori di servizi**: Aziende che forniscono servizi per nostro conto.\n- **Requisiti legali**: Quando richiesto dalla legge.\n- **Trasferimenti aziendali**: In relazione a fusioni o vendite.\n- **Consenso**: Con il vostro consenso esplicito.",
  "privacy_s4_content": "Implementiamo misure di sicurezza standard:\n- Crittografia dei dati in transito (TLS/SSL) e a riposo\n- Supporto autenticazione a due fattori (2FA)\n- Audit di sicurezza regolari\n- Controlli di accesso e autenticazione\n- Elaborazione sicura dei pagamenti",
  "privacy_s5_content": "In base alle leggi sulla protezione dei dati (incluso GDPR), avete diritto a:\n- **Accesso**: Richiedere una copia dei vostri dati\n- **Rettifica**: Richiedere la correzione di dati inesatti\n- **Cancellazione**: Richiedere la cancellazione dei dati\n- **Limitazione**: Richiedere la limitazione del trattamento\n- **Portabilità**: Richiedere il trasferimento in formato leggibile\n- **Opposizione**: Opporsi al trattamento\n- **Revoca del consenso**: Revocare il consenso in qualsiasi momento\n\nContattateci a privacy@infinitybusiness.org.",
  "privacy_s6_content": "Utilizziamo cookie essenziali per la vostra sessione e preferenze. Potete gestire i cookie dal browser.",
  "privacy_s7_content": "Conserviamo i vostri dati solo per il tempo necessario agli scopi per cui sono stati raccolti.",
  "privacy_s8_content": "I vostri dati potrebbero essere trasferiti al di fuori dello SEE. Garantiamo garanzie adeguate.",
  "privacy_s9_content": "Potremmo aggiornare questa informativa periodicamente. I cambiamenti importanti saranno pubblicati su questa pagina.",
  "privacy_s10_content": "Per domande, contattate:\n\n**Liber Nostra d.o.o.**\nEmail: privacy@infinitybusiness.org\nSito: infinitybusiness.org",
  "terms_s1_content": "Benvenuto su Infinity Business (\"infinitybusiness.org\"), gestito da **Liber Nostra d.o.o.**. Accedendo alla nostra piattaforma, accettate questi Termini.",
  "terms_s2_content": "Infinity Business fornisce servizi digitali con IA:\n- Sviluppo web, app mobili e design grafico (B2B)\n- Servizi aziendali e pubblicità digitale\n- Educazione crypto, strumenti di investimento e DeFi (P2P)\n- Assistente IA RisTA\n- Domini e web hosting",
  "terms_s3_content": "Per alcune funzionalità è necessario creare un account. Siete responsabili della riservatezza delle vostre credenziali.",
  "terms_s4_content": "I servizi possono richiedere pagamento. Pagamenti tramite terzi (Stripe, PayPal, crypto). Politiche di rimborso:\n- **Servizi una tantum**: Non rimborsabili.\n- **Abbonamenti**: Cancellabili in qualsiasi momento.\n- **Progetti personalizzati**: Secondo accordo individuale.",
  "terms_s5_content": "Il nostro assistente IA \"RisTA\" fornisce orientamento automatizzato. Solo a scopo informativo.",
  "terms_s6_content": "Tutti i contenuti di questa piattaforma sono proprietà di Liber Nostra d.o.o.",
  "terms_s7_content": "Il vostro utilizzo è regolato anche dalla nostra Informativa sulla Privacy.",
  "terms_s8_content": "I servizi crypto sono solo informativi. Non forniamo consulenza finanziaria.",
  "terms_s9_content": "Liber Nostra d.o.o. non è responsabile per danni indiretti o consequenziali.",
  "terms_s10_content": "Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento.",
  "terms_s11_content": "Questi Termini sono regolati dalle leggi della Repubblica di Slovenia.",
  "terms_s12_content": "Per domande, contattateci o scrivete a support@infinitybusiness.org.",
  "admin_ad_generator": "Generatore Ad",
  "admin_add": "Aggiungi",
  "admin_add_prompt": "Aggiungi prompt",
  "admin_admin": "Admin",
  "admin_advanced_reporting": "Reportistica avanzata",
  "admin_all": "Tutti",
  "admin_analytics_dashboard": "Dashboard Analytics",
  "admin_api_key": "API Key",
  "admin_apply": "Applica",
  "admin_approved": "Approvato",
  "admin_archive": "Archivia",
  "admin_are_you_sure": "Sei sicuro?",
  "admin_audit_alerts": "Avvisi di Audit",
  "admin_author": "Autore",
  "admin_avg_session": "Sessione media",
  "admin_back": "Indietro",
  "admin_badge": "Badge",
  "admin_balance": "Saldo",
  "admin_banned": "Bannato",
  "admin_blog_manager": "Gestore Blog",
  "admin_body": "Body",
  "admin_bounce_rate": "Frequenza di rimbalzo",
  "admin_browser": "Browser",
  "admin_campaign": "Campagna",
  "admin_cannot_undo": "Questa azione non può essere annullata",
  "admin_category": "Categoria",
  "admin_click_rate": "Tasso di clic",
  "admin_close": "Chiudi",
  "admin_completed": "Completato",
  "admin_configuration": "Configurazione",
  "admin_confirm": "Conferma",
  "admin_contact_info": "Info di contatto",
  "admin_content": "Contenuto",
  "admin_conversations": "Conversazioni",
  "admin_conversion_funnel": "Funnel di conversione",
  "admin_conversion_rate": "Tasso di conversione",
  "admin_copied": "Copiato negli appunti",
  "admin_copy": "Copia",
  "admin_count": "Conteggio",
  "admin_country": "Paese",
  "admin_create": "Crea",
  "admin_create_experiment": "Crea esperimento",
  "admin_create_new": "Crea nuovo",
  "admin_created_success": "Creato con successo",
  "admin_credit_config": "Configurazione Crediti",
  "admin_critical": "Critica",
  "admin_custom": "Personalizzato",
  "admin_daily": "Giornaliero",
  "admin_date": "Data",
  "admin_delete_failed": "Eliminazione fallita",
  "admin_deleted_success": "Eliminato con successo",
  "admin_demo_access": "Accesso Demo",
  "admin_description": "Descrizione",
  "admin_deselect_all": "Deseleziona tutto",
  "admin_details": "Dettagli",
  "admin_device": "Dispositivo",
  "admin_disable": "Disabilita",
  "admin_disabled": "Disabilitato",
  "admin_doc_viewer": "Visualizzatore documenti",
  "admin_documentation": "Documentazione",
  "admin_download": "Scarica",
  "admin_draft": "Bozza",
  "admin_duplicate": "Duplica",
  "admin_email": "Email",
  "admin_enable": "Abilita",
  "admin_enabled": "Abilitato",
  "admin_end_date": "Data di fine",
  "admin_endpoint": "Endpoint",
  "admin_error": "Errore",
  "admin_escalation_queue": "Coda di escalation",
  "admin_event": "Evento",
  "admin_events": "Eventi",
  "admin_experiment_name": "Nome esperimento",
  "admin_export": "Esporta",
  "admin_facebook_analytics": "Facebook Analytics",
  "admin_false": "Falso",
  "admin_filter": "Filtra",
  "admin_frequency": "Frequenza",
  "admin_generate": "Genera",
  "admin_headers": "Headers",
  "admin_health_monitoring": "Monitoraggio stato",
  "admin_high": "Alta",
  "admin_high_value_leads": "Lead di alto valore",
  "admin_id": "ID",
  "admin_image": "Immagine",
  "admin_import": "Importa",
  "admin_in_progress": "In corso",
  "admin_inactive": "Inattivo",
  "admin_inbox": "Admin Inbox",
  "admin_speed_audit": "Analisi Velocità",
  "admin_info": "Info",
  "admin_ip_address": "Indirizzo IP",
  "admin_joined": "Iscrizione",
  "admin_knowledge_base": "Knowledge Base",
  "admin_language": "Lingua",
  "admin_last_activity": "Ultima attività",
  "admin_last_login": "Ultimo accesso",
  "admin_last_triggered": "Ultima attivazione",
  "admin_lead_score": "Lead Score",
  "admin_level": "Livello",
  "admin_load_failed": "Caricamento fallito",
  "admin_loading_data": "Caricamento dati...",
  "admin_low": "Bassa",
  "admin_medium": "Media",
  "admin_messages": "Messaggi",
  "admin_method": "Method",
  "admin_monetization": "Monetizzazione",
  "admin_monthly": "Mensile",
  "admin_name": "Nome",
  "admin_next": "Avanti",
  "admin_no": "No",
  "admin_no_data_available": "Nessun dato disponibile",
  "admin_no_experiments": "Nessun esperimento trovato",
  "admin_no_leads": "Nessun lead trovato",
  "admin_no_prompts": "Nessun prompt trovato",
  "admin_no_results": "Nessun risultato",
  "admin_no_results_found": "Nessun risultato trovato",
  "admin_none": "Nessuno",
  "admin_off": "Off",
  "admin_on": "On",
  "admin_open_rate": "Tasso di apertura",
  "admin_page_views": "Visualizzazioni di pagina",
  "admin_partner_badges": "Badge Partner",
  "admin_payload": "Payload",
  "admin_payment_options": "Opzioni di pagamento",
  "admin_platform": "Piattaforma",
  "admin_platform_audit": "Audit della piattaforma",
  "admin_points": "Punti",
  "admin_portfolio_manager": "Gestore Portfolio",
  "admin_preloader_config": "Configurazione Preloader",
  "admin_preview": "Anteprima",
  "admin_previous": "Precedente",
  "admin_price": "Prezzo",
  "admin_priority": "Priorità",
  "admin_prompt_name": "Nome prompt",
  "admin_prompt_text": "Testo del prompt",
  "admin_published": "Pubblicato",
  "admin_recipients": "Destinatari",
  "admin_referral": "Referral",
  "admin_referral_leaderboard": "Classifica Referral",
  "admin_refresh": "Aggiorna",
  "admin_rejected": "Rifiutato",
  "admin_remove": "Rimuovi",
  "admin_reset": "Reimposta",
  "admin_response_time": "Tempo di risposta",
  "admin_restore": "Ripristina",
  "admin_results": "Risultati",
  "admin_retry": "Riprova",
  "admin_revenue_dashboard": "Dashboard entrate",
  "admin_rista_services": "Servizi RisTA",
  "admin_role": "Ruolo",
  "admin_save_changes": "Salva modifiche",
  "admin_save_failed": "Salvataggio fallito",
  "admin_saved_success": "Salvato con successo",
  "admin_scheduled": "Programmato",
  "admin_search": "Cerca",
  "admin_select": "Seleziona",
  "admin_select_all": "Seleziona tutto",
  "admin_send": "Invia",
  "admin_sent_success": "Inviato con successo",
  "admin_server_resources": "Risorse Server",
  "admin_service_manager": "Gestore servizi",
  "admin_session_duration": "Durata sessione",
  "admin_settings": "Impostazioni",
  "admin_slug": "Slug",
  "admin_social_automation": "Automazione Social",
  "admin_something_wrong": "Qualcosa è andato storto",
  "admin_source": "Sorgente",
  "admin_start_date": "Data di inizio",
  "admin_subject": "Oggetto",
  "admin_submit": "Invia",
  "admin_subscribers": "Iscritti",
  "admin_success": "Successo",
  "admin_suspended": "Sospeso",
  "admin_system_prompt": "System Prompt",
  "admin_tags": "Tag",
  "admin_template": "Template",
  "admin_templates": "Template",
  "admin_test_results": "Risultati del test",
  "admin_tester_program": "Programma Tester",
  "admin_title": "Titolo",
  "admin_total_revenue": "Entrate totali",
  "admin_total_sessions": "Sessioni totali",
  "admin_total_users": "Utenti totali",
  "admin_trigger": "Trigger",
  "admin_true": "Vero",
  "admin_try_again": "Riprova",
  "admin_type": "Tipo",
  "admin_unique_visitors": "Visitatori unici",
  "admin_unsubscribed": "Disiscritti",
  "admin_unverified": "Non verificato",
  "admin_update": "Aggiorna",
  "admin_updated_success": "Aggiornato con successo",
  "admin_upload": "Carica",
  "admin_urgent": "Urgente",
  "admin_user": "Utente",
  "admin_variant_a": "Variante A",
  "admin_variant_b": "Variante B",
  "admin_verified": "Verificato",
  "admin_version": "Versione",
  "admin_view": "Visualizza",
  "admin_view_details": "Visualizza dettagli",
  "admin_viewer": "Visualizzatore",
  "admin_warning": "Avviso",
  "admin_webhook_url": "Webhook URL",
  "admin_weekly": "Settimanale",
  "admin_yes": "Sì",
  "admin_analytics_digestadmin_analytics_digest": "Riepilogo analitico",
  "admin_blog_health": "Salute del blog",
  "credit_title": "Crediti",
  "credit_subtitle": "Saldo prepagato per servizi intelligenti",
  "credit_available_balance": "Saldo disponibile",
  "credit_tab_balance": "Saldo",
  "credit_tab_topup": "Ricarica",
  "credit_tab_history": "Cronologia",
  "credit_tab_services": "Servizi",
  "credit_tab_crypto": "Cripto",
  "credit_balance_desc": "Il tuo credito può essere utilizzato per qualsiasi servizio IA:",
  "credit_bulk_discounts": "Sconti quantità",
  "credit_add_credits": "Aggiungi crediti",
  "credit_select_amount": "Seleziona un importo o inserisci un valore:",
  "credit_bonus": "bonus",
  "credit_bonus_detail": "Otterrai",
  "credit_total_word": "totale",
  "credit_method_card": "Carta",
  "credit_method_crypto": "Cripto",
  "credit_processing": "Elaborazione...",
  "credit_add_btn": "Aggiungi",
  "credit_no_txn": "Nessuna transazione",
  "credit_txn_topup": "Ricarica",
  "credit_txn_promo": "Credito promo",
  "credit_txn_auto": "Acquisto auto",
  "credit_txn_purchase": "Acquisto",
  "credit_svc_intelligent": "Servizio intelligente",
  "credit_svc_available": "Disponibile",
  "credit_svc_need_more": "Servono",
  "credit_svc_more": "in più",
  "credit_crypto_send": "Invia",
  "credit_crypto_amount": "Importo:",
  "credit_crypto_equivalent": "equivalente",
  "credit_crypto_network": "Rete:",
  "credit_crypto_wallet": "Indirizzo portafoglio",
  "credit_crypto_confirm": "I crediti verranno aggiunti dopo la conferma della transazione.",
  "credit_payment_id": "ID pagamento:",
  "credit_crypto_back": "Torna alla selezione cripto",
  "credit_crypto_select_title": "Seleziona criptovaluta per la ricarica",
  "credit_crypto_choose_desc": "Scegli una moneta. Riceverai un indirizzo per il pagamento.",
  "credit_crypto_select_btn": "Seleziona",
  "credit_minimum": "Minimo €5",
  "credit_redirecting": "Reindirizzamento...",
  "credit_topup_failed": "Ricarica fallita",
  "credit_crypto_failed": "Pagamento cripto non riuscito",
  "cart_title": "Carrello",
  "cart_total": "Totale",
  "cart_stripe_checkout": "Pagamento Stripe",
  "cart_credits": "Crediti",
  "cart_secure_stripe": "Pagamento sicuro Stripe",
  "cart_insufficient": "Crediti insufficienti. Ricarica prima o scegli il pagamento con carta.",
  "cart_pay_card": "Paga con carta",
  "cart_pay_credits_btn": "Paga con crediti",
  "cart_clear": "Svuota carrello",
  "cart_processing": "Elaborazione...",
  "cart_payment_success": "Pagamento riuscito! Il tuo ordine è in elaborazione.",
  "cart_complete_setup": "Completa la configurazione",
  "cart_also_added": "I clienti con acquisti simili hanno aggiunto anche:",
  "cart_add": "Aggiungi",
  "cart_standard": "Standard",
  "cart_remaining_balance": "Saldo rimanente:",
  "cart_checkout_failed": "Pagamento fallito",
  "cart_checkout_no_session": "Impossibile creare la sessione di pagamento",
  "cart_purchased": "Acquistato",
  "cart_services_with_credits": "servizio/i con crediti!",
  "credits_balance_title": "Saldo crediti",
  "credits_topup_btn": "Ricarica crediti",
  "credits_rate": "1 EUR = 1 Credito",
  "credits_total_topup": "Totale ricaricato",
  "credits_spent_credits": "Speso (Crediti)",
  "credits_spent_payments": "Speso (Pagamenti)",
  "credits_txn_history": "Cronologia transazioni",
  "credits_no_txn": "Nessuna transazione",
  "credits_txn_topup": "Ricarica",
  "credits_txn_promo": "Credito promo",
  "credits_txn_purchase": "Acquisto servizio",
  "credits_txn_ai": "Servizio IA",
  "credits_order_history": "Cronologia ordini",
  "credits_order_label": "Ordine:",
  "chat_translate_btn": "Traduci in inglese",
  "chat_translating": "Traduzione...",
  "chat_translated_label": "Traduzione inglese visualizzata. Clicca \"Mostra originale\" per i messaggi originali.",
  "chat_show_original": "Mostra originale",
  "chat_show_translated": "Mostra traduzione",
  "pkg_section_badge": "Offerte a Tempo Limitato",
  "pkg_section_title": "Lancia il Tuo Business",
  "pkg_section_title_highlight": "Oggi",
  "pkg_section_subtitle": "Pacchetti premium progettati per portarti online rapidamente — con tecnologia intelligente integrata sin dal primo giorno.",
  "pkg_section_footer": "Tutti i prezzi escludono l'IVA ove applicabile. Non sei sicuro di quale pacchetto si adatti? Chatta con RisTA per una consulenza gratuita.",
  "pkg_cta_default": "Inizia",
  "admin_package_mgr": "Gestore Pacchetti",
  "admin_pkg_title": "Pacchetti per Landing Page",
  "admin_pkg_subtitle": "Gestisci i pacchetti di prezzo evidenziati mostrati sulla pagina di atterraggio",
  "admin_pkg_seed": "Impostazioni Predefinite",
  "admin_pkg_new": "Nuovo Pacchetto",
  "admin_pkg_create_title": "Crea Nuovo Pacchetto",
  "admin_pkg_edit_title": "Modifica Pacchetto",
  "admin_pkg_name": "Nome del Pacchetto",
  "admin_pkg_tagline": "Slogan",
  "admin_pkg_description": "Descrizione",
  "admin_pkg_price": "Prezzo",
  "admin_pkg_currency": "Valuta",
  "admin_pkg_price_note": "Nota sul Prezzo",
  "admin_pkg_badge": "Badge",
  "admin_pkg_accent": "Colore Accento",
  "admin_pkg_cta_text": "Testo del Pulsante CTA",
  "admin_pkg_cta_link": "Link CTA (opzionale)",
  "admin_pkg_sort": "Ordine di Ordinamento",
  "admin_pkg_features": "Caratteristiche / Servizi Inclusi",
  "admin_pkg_add_feature": "Aggiungi Caratteristica",
  "admin_pkg_highlighted": "Evidenziato",
  "admin_pkg_normal": "Normale",
  "admin_pkg_create": "Crea Pacchetto",
  "admin_pkg_save": "Salva Modifiche",
  "admin_pkg_saving": "Salvataggio...",
  "admin_pkg_cancel": "Annulla",
  "admin_pkg_empty_title": "Nessun pacchetto configurato ancora",
  "admin_pkg_empty_desc": "Clicca su Impostazioni Predefinite per generare due pacchetti di avvio, o crea il tuo.",
  "admin_pkg_features_label": "caratteristiche",
  "admin_pkg_sort_label": "Ordinamento",
  "admin_pkg_delete_confirm": "Eliminare questo pacchetto? Verrà rimosso dalla pagina di atterraggio.",
  "admin_pkg_feature_placeholder": "Descrizione della caratteristica...",
  "admin_pkg_pricenote_placeholder": "es. Una tantum / +5% condivisione ricavi",
  "admin_pkg_badge_placeholder": "es. MIGLIOR VALORE",
  "admin_pkg_loading": "Caricamento pacchetti...",
  "pkg_qa_have_domain": "S00ec, ho un dominio",
  "pkg_qa_need_domain": "Ho bisogno di un dominio",
  "pkg_qa_describe_biz": "Lasciatemi descrivere la mia attivit00e0",
  "pkg_qa_more_info": "Dimmi di più su questo pacchetto",
  "sp_addon_title": "Add-on e Supporto",
  "sp_addon_desc": "Potenzia il tuo progetto con supporto prioritario e consulenza esperta.",
  "sp_research_title": "Prodotti di Ricerca Intelligente",
  "sp_research_desc": "Intelligence di mercato on-demand e strumenti di analisi intelligente.",
  "tier_section_badge": "Pacchetti Intelligenti",
  "tier_section_title": "Scegli il Tuo",
  "tier_section_highlight": "Piano di Crescita",
  "tier_section_subtitle": "Pacchetti progettati per il massimo valore. Scegli il livello adatto a te.",
  "tier_one_time": "Una Tantum",
  "tier_monthly": "Mensile",
  "tier_section_footer": "Tutti i prezzi sono IVA esclusa. Serve un pacchetto personalizzato? Chatta con RisTA.",
  "tier_name_starter": "Starter",
  "tier_name_growth": "Growth",
  "tier_name_pro": "Pro",
  "tier_name_enterprise": "Enterprise",
  "tier_tag_starter": "Perfetto per iniziare la tua presenza digitale",
  "tier_tag_growth": "Scala il tuo business con strumenti intelligenti",
  "tier_tag_pro": "Crescita digitale completa per aziende serie",
  "tier_tag_enterprise": "Trasformazione digitale completa",
  "tier_cta_starter": "Scegli Starter",
  "tier_cta_growth": "Scegli Growth",
  "tier_cta_pro": "Scegli Pro",
  "tier_cta_enterprise": "Scegli Enterprise",
  "tier_badge_popular": "POPOLARE",
  "tier_badge_best": "MIGLIOR VALORE",
  "tier_badge_all": "TUTTO IN UNO",
  "tier_per_mo": "mese",
  "tier_once_label": "una tantum",
  "tier_or_monthly": "o",
  "tier_f_starter_1": "Generatore intelligente di business plan",
  "tier_f_starter_2": "Builder intelligente di CV (3 pezzi)",
  "tier_f_starter_3": "Audit web e report SEO",
  "tier_f_starter_4": "Logo e kit brand intelligente",
  "tier_f_starter_5": "Report panoramica mercato",
  "tier_f_starter_6": "Bozza risposte FAQ",
  "tier_f_starter_7": "Schema blog da trend",
  "tier_f_starter_8": "Supporto email entro 48h",
  "tier_f_growth_1": "Tutto dallo Starter",
  "tier_f_growth_2": "Campagna email intelligente",
  "tier_f_growth_3": "Calendario e analisi social (3 mesi)",
  "tier_f_growth_4": "Report analisi competitor",
  "tier_f_growth_5": "Generatore annunci (5 campagne)",
  "tier_f_growth_6": "Generatore email outreach",
  "tier_f_growth_7": "Spiegazione tendenze",
  "tier_f_growth_8": "Analisi posizionamento",
  "tier_f_growth_9": "Supporto email prioritario entro 24h",
  "tier_f_pro_1": "Tutto dal Growth",
  "tier_f_pro_2": "Setup SEO e marketing digitale",
  "tier_f_pro_3": "Setup email marketing",
  "tier_f_pro_4": "Scrittore intelligente script video (5 pezzi)",
  "tier_f_pro_5": "Schizzo logica TAM rapido",
  "tier_f_pro_6": "Checklist rischi",
  "tier_f_pro_7": "Prioritizzazione funzionalità",
  "tier_f_pro_8": "Bozza lista fornitori",
  "tier_f_pro_9": "Sessione consulenza intelligente (2h)",
  "tier_f_pro_10": "Supporto prioritario entro 12h",
  "tier_f_ent_1": "Tutto dal Pro",
  "tier_f_ent_2": "Sviluppo software personalizzato",
  "tier_f_ent_3": "Strategia pubblicitaria enterprise",
  "tier_f_ent_4": "Hosting gestito (12 mesi)",
  "tier_f_ent_5": "Piano manutenzione (6 mesi)",
  "tier_f_ent_6": "Consulenza intelligente (10h)",
  "tier_f_ent_7": "Verifica ingresso paese",
  "tier_f_ent_8": "Sommario esecutivo per slide",
  "tier_f_ent_9": "Dichiarazione problema JTBD",
  "tier_f_ent_10": "Account manager dedicato",
  "tier_f_ent_11": "Coda prioritaria (risposta 4h)",
  "calc_title": "Calcolatore Prezzi",
  "calc_subtitle": "Confronta servizi singoli con pacchetti per vedere i risparmi.",
  "calc_badge": "Risparmia di Più",
  "calc_select_services": "Seleziona Servizi",
  "calc_search_placeholder": "Cerca servizi...",
  "calc_selected": "selezionati",
  "calc_your_selection": "La Tua Selezione",
  "calc_individual_total": "Totale Individuale",
  "calc_best_tier": "Miglior Pacchetto",
  "calc_you_save": "Risparmi",
  "calc_no_services": "Seleziona servizi per vedere i risparmi",
  "calc_clear_all": "Cancella tutto",
  "calc_get_tier": "Ottieni Questo Pacchetto",
  "calc_individual_cheaper": "I servizi individuali sono già convenienti. Aggiungine altri!",
  "referred_by": "Raccomandato da",
  "referral_signup_reward": "Registrati per collegare il tuo account a questo referral.",
  "badge_coming_soon": "Prossimamente",
  "badge_available_soon": "Disponibile a breve",
  "badge_from_price": "da",
  "badge_preparing": "Stiamo preparando questo servizio per te",
  "svc_managed-hosting_label": "Hosting gestito",
  "svc_managed-hosting_desc": "Hosting completamente gestito con monitoraggio e supporto",
  "svc_enterprise-advertising_label": "Pubblicità aziendale",
  "svc_enterprise-advertising_desc": "Campagne pubblicitarie su larga scala con strategia dedicata",
  "svc_email-marketing_label": "Configurazione email marketing",
  "svc_email-marketing_desc": "Sequenze email professionali, template e automazione",
  "svc_competitor-analysis_label": "Report analisi competitiva",
  "svc_competitor-analysis_desc": "Intelligence di mercato e posizionamento competitivo",
  "svc_legal-docs_label": "Generatore documenti legali",
  "svc_legal-docs_desc": "NDA, contratti, modelli termini di servizio",
  "svc_website-audit_label": "Audit web e report SEO",
  "svc_website-audit_desc": "Analisi completa del sito con raccomandazioni",
  "svc_trading-consultation_label": "Consulenze di trading",
  "svc_trading-consultation_desc": "Sessioni di strategia di trading guidate da esperti",
  "svc_managed-trading_label": "Trading gestito",
  "svc_managed-trading_desc": "Trading gestito da esperti con strategie comprovate",
  "svc_domain-management_label": "Gestione domini",
  "svc_domain-management_desc": "Registrazione domini, gestione DNS e trasferimenti",
  "svc_personal-branding_label": "Personal branding",
  "svc_personal-branding_desc": "Costruisci la tua presenza online e il tuo brand personale",
  "admin_escalation_alert": "Escalation chat",
  "admin_view_escalations": "Vedi coda escalation",
  "from": "Da",
  "vector_gen_title": "Generatore vettoriale",
  "vector_gen_title_hl": "intelligente",
  "vector_gen_badge": "Studio vettoriale intelligente",
  "vector_gen_desc": "Descrivi la tua idea, carica i riferimenti e ottieni un grafico vettoriale SVG pronto per la produzione in pochi secondi.",
  "vector_gen_balance": "Il tuo saldo",
  "vector_gen_per_gen": "crediti per generazione",
  "vector_gen_prompt_label": "Descrivi il tuo grafico vettoriale",
  "vector_gen_prompt_ph": "es. Un logo minimalista di montagna con raggi di sole, usando colori teal e arancione...",
  "vector_gen_style": "Stile",
  "vector_gen_color": "Modalità colore",
  "vector_gen_refs": "File di riferimento",
  "vector_gen_optional": "opzionale, max 3",
  "vector_gen_upload": "Carica riferimento (PNG, JPG, SVG)",
  "vector_gen_generating": "Generazione in corso...",
  "vector_gen_cta": "Genera vettore",
  "vector_gen_result": "Il tuo grafico vettoriale",
  "vector_gen_model_used": "Modello",
  "vector_gen_history": "Cronologia generazioni",
  "vector_gen_no_history": "Nessuna generazione ancora",
  "vector_gen_login_req": "Accedi per utilizzare il generatore vettoriale.",
  "vector_gen_service_title": "Hai bisogno di vettori professionali?",
  "vector_gen_service_desc": "Ordina grafiche vettoriali personalizzate come servizio di design completo con revisioni e linee guida del brand.",
  "vector_gen_service_cta": "Vedi servizi di design",
  "vector_gen_product_type": "Tipo di prodotto",
  "vector_gen_size": "Dimensione output",
  "vector_gen_error_prompt": "Descrivi la tua idea per la grafica vettoriale.",
  "admin_vector_gen": "Generatore vettoriale",
  "admin_showroom": "Showroom",
  "admin_landing_page": "Pagina di destinazione",
  "admin_landing_text": "Testi pagina di destinazione",
  "admin_vector_title": "Generatore vettoriale",
  "admin_vector_models": "Modelli disponibili",
  "admin_vector_pricing": "Prezzi e limiti",
  "svc_vector-generator_label": "Generatore vettoriale intelligente",
  "svc_vector-generator_desc": "Genera grafiche vettoriali SVG pronte per la produzione da descrizioni testuali",
  "sp_vector_gen_name": "Generatore vettoriale intelligente",
  "sp_vector_gen_desc": "Genera grafiche vettoriali SVG da descrizioni testuali con tecnologia intelligente.",
  "sp_vector_gen_feat": "Generazione testo-vettore|Esportazione SVG e PNG|Preset di stile multipli|Editor SVG inline|Caricamento riferimenti|Prezzi basati su crediti",
  "sp_managed_hosting_name": "Hosting gestito",
  "sp_managed_hosting_feat": "Monitoraggio 24/7|Aggiornamenti auto|Gestione SSL|Backup giornalieri|Ottimizzazione|Supporto dedicato",
  "sp_enterprise_ad_name": "Pubblicità enterprise",
  "sp_enterprise_ad_feat": "Strategia campagna|Multi-canale|Test A/B|Tracciamento|Manager dedicato|Report",
  "sp_email_marketing_name": "Setup email marketing",
  "sp_email_marketing_feat": "Sequenze email|Design template|Automazione|Gestione liste|Analytics|Test A/B",
  "sp_competitor_analysis_name": "Report analisi concorrenza",
  "sp_competitor_analysis_feat": "Analisi di mercato|Profilo concorrenti|SWOT|Confronto prezzi|Raccomandazioni|Aggiornamenti",
  "sp_website_audit_name": "Audit sito web e report SEO",
  "sp_website_audit_feat": "Audit tecnico|Analisi SEO|Metriche|Accessibilità|Scansione sicurezza|Piano d'azione",
  "sp_defi_name": "Soluzioni DeFi",
  "sp_defi_feat": "Smart contract|Yield farming|Pool di liquidità|Audit DeFi|Creazione token|Soluzioni di staking",
  "sp_personal_brand_name": "Personal branding",
  "sp_personal_brand_feat": "Strategia di brand|Presenza social media|Sito web personale|Pianificazione contenuti|Foto professionali|Scrittura bio",
  "sp_ad_gen_name": "Generatore di annunci",
  "sp_ad_gen_feat": "Testi pubblicitari|Formati creativi|Multi-piattaforma|Varianti A/B|Targeting pubblico|Consigli prestazioni",
  "sp_priority_name": "Coda prioritaria",
  "sp_priority_feat": "Risposta 4 ore|Canale dedicato|Elaborazione prioritaria|Aggiornamenti stato|Garanzia SLA|Supporto esteso",
  "sp_maintenance_name": "Piano di manutenzione",
  "sp_maintenance_feat": "Aggiornamenti mensili|Patch di sicurezza|Monitoraggio prestazioni|Correzione bug|Garanzia uptime|Supporto prioritario",
  "sp_consulting_name": "Sessione di consulenza intelligente",
  "sp_consulting_feat": "Consulenza esperta|Sessione strategica|Consulenza tecnica|Piano di implementazione|Note di follow-up|Registrazione inclusa",
  "sp_market_snapshot_name": "Panoramica di mercato",
  "sp_market_snapshot_feat": "Panoramica del mercato|Tendenze chiave|Panorama competitivo|Opportunità di crescita|Fattori di rischio|Sintesi esecutiva",
  "sp_trend_explainer_name": "Spiegazione tendenze",
  "sp_trend_explainer_feat": "Analisi tendenze|Impatto settoriale|Valutazione opportunità|Proiezione temporale|Azioni|Report visivo",
  "sp_competitor_qa_name": "Domande concorrenti",
  "sp_competitor_qa_feat": "Analisi strategica|Approfondimenti prezzi|Posizionamento|Confronto|Analisi debolezze|Mappa opportunità",
  "sp_country_entry_name": "Verifica ingresso mercato",
  "sp_country_entry_feat": "Preparazione mercato|Panorama normativo|Fattori culturali|Analisi competitiva|Strategia di ingresso|Valutazione rischi",
  "sp_vendor_shortlist_name": "Lista ristretta fornitori",
  "sp_vendor_shortlist_feat": "Ricerca fornitori|Matrice comparativa|Analisi prezzi|Valutazione capacità|Raccomandazioni|Dati di contatto",
  "sp_tam_logic_name": "Schema logica TAM",
  "sp_tam_logic_feat": "Stima TAM|Dettaglio SAM/SOM|Framework logico|Fonti dati|Ipotesi di crescita|Presentazione visiva",
  "sp_positioning_name": "Angolo di posizionamento",
  "sp_positioning_feat": "Posizionamento di mercato|Segmentazione pubblico|Proposta di valore|Framework messaggi|Differenziazione|Vantaggio competitivo",
  "sp_managed_trading_name": "Trading gestito",
  "sp_managed_trading_feat": "Gestione portfolio|Gestione rischi|Strategie comprovate|Report regolari|Manager dedicato|Analisi di mercato",
  "sp_trading_consult_name": "Consulenza trading",
  "sp_trading_consult_feat": "Sessioni individuali|Sviluppo strategia|Analisi mercato|Valutazione rischi|Revisione portfolio|Guida esperta",
  "sp_domains_name": "Mercato LiveDomain",
  "sp_domains_feat": "Domini premium|Offerte aftermarket|Valutazione domini|Supporto trasferimento|Negoziazione|Gestione portfolio",
  "sp_domain_mgmt_name": "Gestione domini",
  "sp_domain_mgmt_feat": "Gestione DNS|Rinnovo auto|Supporto trasferimento|Tracking portfolio|Certificati SSL|Privacy Whois",
  "sp_managed_hosting_desc": "Hosting completamente gestito con monitoraggio, aggiornamenti e supporto dedicato.",
  "sp_enterprise_ad_desc": "Campagne pubblicitarie su larga scala con strategia e gestione dedicate.",
  "sp_email_marketing_desc": "Sequenze email professionali, template e automazione marketing.",
  "sp_competitor_analysis_desc": "Analisi approfondita del mercato e posizionamento competitivo.",
  "sp_website_audit_desc": "Analisi completa del sito con raccomandazioni operative.",
  "sp_managed_trading_desc": "Trading gestito da esperti con strategie collaudate e gestione del rischio.",
  "sp_trading_consult_desc": "Sessioni individuali di strategia di trading guidate da esperti.",
  "sp_domains_desc": "Acquisizione di domini premium e offerte aftermarket.",
  "sp_domain_mgmt_desc": "Gestione DNS, rinnovi, trasferimenti e cura del portfolio domini.",
  "sp_defi_desc": "Smart contract, yield farming e soluzioni per pool di liquidità.",
  "sp_personal_brand_desc": "Costruisci la tua presenza online e l'identità del tuo brand personale.",
  "sp_ad_gen_desc": "Genera copy pubblicitari e creatività ad alta conversione istantaneamente.",
  "sp_priority_desc": "Ottieni una risposta entro 4 ore garantita.",
  "sp_maintenance_desc": "Manutenzione continua, aggiornamenti e supporto tecnico.",
  "sp_consulting_desc": "Consulenza individuale con i nostri esperti di tecnologia intelligente.",
  "sp_market_snapshot_desc": "Panoramica rapida del panorama di mercato e delle tendenze.",
  "sp_trend_explainer_desc": "Comprendi le tendenze emergenti rilevanti per il tuo settore.",
  "sp_competitor_qa_desc": "Ottieni risposte sulle strategie dei tuoi concorrenti.",
  "sp_country_entry_desc": "Valuta la preparazione del mercato per l'espansione internazionale.",
  "sp_vendor_shortlist_desc": "Lista curata di fornitori per le tue esigenze specifiche.",
  "sp_tam_logic_desc": "Stima del mercato totale indirizzabile con analisi logica.",
  "sp_positioning_desc": "Analisi di posizionamento prodotto + pubblico.",
  "vector_gen_model": "Modello",
  "vector_gen_quality": "Livello di qualità",
  "svc_smart-resume_label": "Generatore intelligente di CV",
  "svc_smart-resume_desc": "CV ottimizzati per ATS dal nostro sistema intelligente",
  "svc_smart-business-plan_label": "Generatore intelligente di business plan",
  "svc_smart-business-plan_desc": "Business plan completo con finanze e analisi di mercato",
  "svc_smart-seo-report_label": "Report SEO intelligente",
  "svc_smart-seo-report_desc": "Analisi automatizzata del sito con raccomandazioni operative",
  "svc_smart-brand-kit_label": "Kit logo e brand intelligente",
  "svc_smart-brand-kit_desc": "Concept logo, palette colori, tipografia e asset social media",
  "svc_smart-email-campaign_label": "Campagna email intelligente",
  "svc_smart-email-campaign_desc": "Email marketing intelligente con sequenze ottimizzate",
  "svc_smart-social-calendar_label": "Calendario e analisi social media",
  "svc_smart-social-calendar_desc": "30 giorni di post generati con strategia di engagement",
  "svc_ad-generator_label": "Generatore di annunci",
  "svc_ad-generator_desc": "Genera istantaneamente copy pubblicitari ad alta conversione",
  "svc_smart-translation_label": "Servizi di traduzione intelligenti",
  "svc_smart-translation_desc": "Traduzione professionale di documenti in oltre 50 lingue",
  "svc_smart-video-script_label": "Scrittore intelligente di script video",
  "svc_smart-video-script_desc": "Script YouTube, TikTok e pubblicitari ottimizzati per l'engagement",
  "svc_priority-queue_label": "Coda prioritaria",
  "svc_priority-queue_desc": "Risposta garantita entro 4 ore",
  "svc_maintenance-plan_label": "Piano di manutenzione",
  "svc_maintenance-plan_desc": "Manutenzione continua, aggiornamenti e supporto tecnico",
  "svc_smart-consulting_label": "Sessione di consulenza intelligente",
  "svc_smart-consulting_desc": "Consulenza individuale con i nostri esperti di tecnologia",
  "svc_market-snapshot_label": "Panoramica di mercato",
  "svc_market-snapshot_desc": "Panoramica rapida del mercato",
  "svc_trend-explainer_label": "Spiegazione tendenze",
  "svc_trend-explainer_desc": "Comprendi le tendenze emergenti del tuo settore",
  "svc_competitor-qa_label": "Domande concorrenti",
  "svc_competitor-qa_desc": "Ottieni risposte sulle strategie dei tuoi concorrenti",
  "svc_country-entry-check_label": "Verifica ingresso mercato",
  "svc_country-entry-check_desc": "Valuta la preparazione del mercato per l'espansione internazionale",
  "svc_should-i-care_label": "Verifica rilevanza",
  "svc_should-i-care_desc": "Valuta se un trend è importante per il tuo business",
  "svc_report-matchmaker_label": "Trova report",
  "svc_report-matchmaker_desc": "Trova il report di ricerca giusto",
  "svc_which-region-first_label": "Priorità regionale",
  "svc_which-region-first_desc": "Guida basata sui dati per l'ingresso nel mercato regionale",
  "svc_vendor-shortlist_label": "Lista ristretta fornitori",
  "svc_vendor-shortlist_desc": "Lista curata di fornitori per le tue esigenze",
  "svc_forecast-explanation_label": "Spiegazione previsioni",
  "svc_forecast-explanation_desc": "Spiegazione chiara delle previsioni di mercato",
  "svc_outreach-email-gen_label": "Generatore email di contatto",
  "svc_outreach-email-gen_desc": "Genera email di contatto personalizzate su scala",
  "svc_executive-summary_label": "Sintesi per la dirigenza",
  "svc_executive-summary_desc": "Sintesi pronte per le presentazioni",
  "svc_faq-answer-draft_label": "Bozza risposte FAQ",
  "svc_faq-answer-draft_desc": "Bozze di risposte alle domande più frequenti",
  "svc_jtbd-problem_label": "Dichiarazione problema JTBD",
  "svc_jtbd-problem_desc": "Analisi del problema con framework JTBD",
  "svc_tam-logic-sketch_label": "Schema logica TAM",
  "svc_tam-logic-sketch_desc": "Stima del mercato totale con analisi logica",
  "svc_risk-checklist_label": "Checklist rischi",
  "svc_risk-checklist_desc": "Checklist completa di valutazione dei rischi",
  "svc_feature-prioritization_label": "Prioritizzazione funzionalità",
  "svc_feature-prioritization_desc": "Raccomandazioni di prioritizzazione basate sui dati",
  "svc_next-research-question_label": "Prossima domanda di ricerca",
  "svc_next-research-question_desc": "Scopri la prossima domanda di ricerca critica",
  "svc_positioning-angle_label": "Angolo di posizionamento",
  "svc_positioning-angle_desc": "Analisi di posizionamento prodotto e pubblico",
  "svc_blog-outline-trend_label": "Schema blog da trend",
  "svc_blog-outline-trend_desc": "Trasforma i temi di tendenza in schemi blog strutturati",
  "admin_ai_reports": "Report servizi AI",
  "admin_project_delivery": "Consegna progetto",
  "admin_analytics_digest": "[TRANSLATE] Analytics Digest",
  "admin_seo_suggestions": "[TRANSLATE] SEO Optimization",
  "admin_visitor_map": "[TRANSLATE] Visitor Map",
  "admin_competitor_monitor": "[TRANSLATE] Competitor Intelligence",
  "admin_email_workflows": "[TRANSLATE] Email Workflows",
  "admin_collab_editing": "[TRANSLATE] Team Collaboration",
  "admin_status_online": "[TRANSLATE] Online",
  "admin_status_offline": "[TRANSLATE] Offline",
  "admin_status_online_desc": "[TRANSLATE] You are visible as online. Users requesting escalation will be connected to you.",
  "admin_status_offline_desc": "[TRANSLATE] You are offline. Users requesting escalation will see a message to try later.",
  "admin_ai_model": "[TRANSLATE] AI Model",
  "admin_prompts": "[TRANSLATE] Prompts",
  "admin_no_escalations": "[TRANSLATE] No escalations in queue.",
  "blog_edit": "[TRANSLATE] Edit Post",
  "admin_card_visibility": "[TRANSLATE] Card Visibility",
  "sp_managed_hosting": "[TRANSLATE] Managed Hosting",
  "sp_enterprise_ad": "[TRANSLATE] Enterprise Advertising",
  "sp_email_marketing": "[TRANSLATE] Email Marketing Setup",
  "sp_competitor_analysis": "[TRANSLATE] Competitor Analysis Report",
  "sp_website_audit": "[TRANSLATE] Website Audit & SEO Report",
  "sp_managed_trading": "[TRANSLATE] Managed Trading",
  "sp_trading_consult": "[TRANSLATE] Trading Consultations",
  "sp_domains": "[TRANSLATE] LiveDomain Aftermarket",
  "sp_domain_mgmt": "[TRANSLATE] Domain Management",
  "sp_defi": "[TRANSLATE] DeFi Solutions",
  "sp_personal_brand": "[TRANSLATE] Personal Branding",
  "sp_ad_gen": "[TRANSLATE] Ad Generator",
  "sp_priority": "[TRANSLATE] Priority Queue",
  "sp_maintenance": "[TRANSLATE] Maintenance Plan",
  "sp_consulting": "[TRANSLATE] Smart Consulting Session",
  "sp_market_snapshot": "[TRANSLATE] Market Snapshot",
  "sp_trend_explainer": "[TRANSLATE] Trend Explainer",
  "sp_competitor_qa": "[TRANSLATE] Competitor Q&A",
  "sp_country_entry": "[TRANSLATE] Country Entry Check",
  "sp_vendor_shortlist": "[TRANSLATE] Vendor Shortlist Draft",
  "sp_tam_logic": "[TRANSLATE] Quick TAM Logic Sketch",
  "sp_positioning": "[TRANSLATE] Positioning Angle",
  "agency_rista_tooltip": "Chatta con RisTA",
  "agency_hero_title_1": "Siti web ultraveloci che ",
  "agency_hero_title_highlight": "vendono",
  "agency_hero_title_2": " per le attività locali",
  "agency_hero_subtitle_1": "Ottieni un sito personalizzato che carica in millisecondi + analisi integrate per",
  "agency_hero_subtitle_2": ". Nessuna pagina lenta, più contatti — lancio in settimane.",
  "agency_hero_limited": "Posti limitati!",
  "agency_hero_cta_pricing": "Vedi pacchetto €498",
  "agency_hero_cta_audit": "Audit gratuito",
  "agency_trust_maintenance": "manutenzione dopo",
  "agency_trust_efficient": "100% Efficiente",
  "agency_trust_powered": "Alimentato da Sistema Intelligente",
  "agency_speed_title": "Velocità di caricamento",
  "agency_speed_before": "Prima",
  "agency_speed_after": "Dopo",
  "agency_speed_leads": "+35% contatti",
  "agency_pain_title_1": "I siti lenti ",
  "agency_pain_title_2": "uccidono le vendite",
  "agency_pain_subtitle": "Ogni secondo di caricamento del tuo sito, perdi clienti. Ecco il problema — e come lo risolviamo.",
  "agency_pain_slow_title": "Caricamento lento = Contatti persi",
  "agency_pain_slow_desc": "Il tuo sito impiega più di 5 secondi a caricare. I visitatori se ne vanno prima di vedere la tua offerta.",
  "agency_pain_stats_title": "47% abbandona se >3s",
  "agency_pain_stats_desc": "La ricerca di Google mostra che quasi la metà dei visitatori abbandona un sito mobile che impiega più di 3 secondi a caricare.",
  "agency_pain_stats_source": "Fonte: Google/SOASTA Research, 2017",
  "agency_pain_solution_title": "La nostra tecnologia Speed-First",
  "agency_pain_solution_desc": "Siti personalizzati ottimizzati per caricare in meno di 1 secondo. Cache edge, immagini ottimizzate, codice minimizzato.",
  "agency_pricing_title": "Prezzi semplici e trasparenti",
  "agency_pricing_subtitle": "Scegli il piano adatto alla tua attività. Tutti i piani includono la nostra tecnologia Speed-First.",
  "agency_pricing_urgency_1": "Solo ",
  "agency_pricing_urgency_2": " posti starter rimasti questo mese",
  "agency_pricing_popular": "PIÙ POPOLARE",
  "agency_pricing_get_started": "Inizia ora",
  "agency_pricing_guarantee": "Garanzia soddisfatti o rimborsati 30 giorni",
  "agency_pricing_ideal": "Ideale per:",
  "agency_pricing_starter": "Starter",
  "agency_pricing_onetime": "una tantum",
  "agency_pricing_starter_ideal": "Imprenditori individuali",
  "agency_pricing_s_1": "Sito web personalizzato ultraveloce",
  "agency_pricing_s_2": "Dominio + hosting per 1 anno",
  "agency_pricing_s_3": "Dashboard analisi base",
  "agency_pricing_s_4": "Design responsive per mobile",
  "agency_pricing_s_5": "Certificato SSL incluso",
  "agency_pricing_performance": "Performance",
  "agency_pricing_perf_ideal": "Negozi in crescita",
  "agency_pricing_p_1": "Tutto dello Starter",
  "agency_pricing_p_2": "E-commerce + recupero carrello",
  "agency_pricing_p_3": "Pacchetto ottimizzazione SEO",
  "agency_pricing_p_4": "Integrazione test A/B",
  "agency_pricing_p_5": "Supporto prioritario",
  "agency_pricing_premium": "Premium",
  "agency_pricing_prem_ideal": "Aziende in espansione",
  "agency_pricing_pr_1": "Tutto del Performance",
  "agency_pricing_pr_2": "Gestione Google Ads",
  "agency_pricing_pr_3": "Audit settimanali delle prestazioni",
  "agency_pricing_pr_4": "Account manager dedicato",
  "agency_pricing_pr_5": "Integrazioni personalizzate",
  "agency_social_title": "La fiducia delle attività locali",
  "agency_social_rista_label": "RisTA AI:",
  "agency_social_rista_quote": "Analizzo il comportamento dei visitatori in tempo reale per aumentare le tue conversioni.",
  "agency_social_see_clients": "Cosa dicono i nostri clienti",
  "agency_social_t1_name": "Marko K.",
  "agency_social_t1_role": "CEO, Negozio locale",
  "agency_social_t1_text": "Abbiamo raddoppiato i contatti nel primo mese! Il sito carica istantaneamente e i nostri clienti adorano il nuovo design.",
  "agency_social_t2_name": "Elena V.",
  "agency_social_t2_role": "Proprietaria ristorante",
  "agency_social_t2_text": "I nostri ordini online sono aumentati del 40% dopo il lancio. La differenza di velocità è abissale.",
  "agency_social_t3_name": "Thomas H.",
  "agency_social_t3_role": "Studio fitness",
  "agency_social_t3_text": "Professionale, veloce e mantengono davvero le promesse. Il nostro tasso di prenotazione è salito del 35% in sole 3 settimane.",
  "agency_social_t4_name": "Ana S.",
  "agency_social_t4_role": "Proprietaria boutique",
  "agency_social_t4_text": "L'impostazione e-commerce è stata perfetta. Il solo recupero carrello ha ripagato il piano Performance nel primo trimestre.",
  "agency_social_metric_1": "Tempo medio di caricamento",
  "agency_social_metric_2": "Più contatti",
  "agency_social_metric_3": "Soddisfazione cliente",
  "agency_services_title": "Tutto ciò di cui la tua attività ha bisogno",
  "agency_services_subtitle": "Soluzioni digitali complete per far crescere la tua presenza online.",
  "agency_svc_fast_title": "Siti web veloci",
  "agency_svc_fast_desc": "Siti personalizzati che caricano in meno di 1 secondo. Mobile-first, ottimizzati SEO.",
  "agency_svc_ecom_title": "Negozi E-Commerce",
  "agency_svc_ecom_desc": "Vendi online con recupero carrello, elaborazione pagamenti e gestione inventario.",
  "agency_svc_seo_title": "Audit SEO e Ottimizzazione",
  "agency_svc_seo_desc": "Posizionati più in alto su Google. SEO tecnico, strategia contenuti e report mensili.",
  "agency_svc_ads_title": "Configurazione Google Ads",
  "agency_svc_ads_desc": "Ottieni traffico mirato velocemente. Configurazione campagna, ottimizzazione e tracciamento ROI inclusi.",
  "agency_svc_maint_title": "Manutenzione & Supporto",
  "agency_svc_maint_desc": "Hosting, aggiornamenti sicurezza, backup e modifiche contenuto. Da €30/mese.",
  "agency_faq_title": "Domande frequenti",
  "agency_faq_q1": "Quanto velocemente caricherà il mio sito?",
  "agency_faq_a1": "Meno di 1 secondo. Ottimizziamo ogni millisecondo — dalla risposta del server al rendering visuale completo.",
  "agency_faq_q2": "Cosa include il pacchetto Starter da €498?",
  "agency_faq_a2": "Un sito ultraveloce personalizzato, dominio e hosting per 1 anno, dashboard analisi, design responsive e certificato SSL.",
  "agency_faq_q3": "Quanto tempo serve per il lancio?",
  "agency_faq_a3": "La maggior parte dei progetti Starter viene lanciata in 2-3 settimane. I piani Performance e Premium richiedono 4-6 settimane.",
  "agency_faq_q4": "Offrite manutenzione continua?",
  "agency_faq_a4": "Sì. Dopo il primo anno, la manutenzione parte da €30/mese, inclusi hosting, aggiornamenti sicurezza e modifiche minori.",
  "agency_faq_q5": "Posso aggiornare il mio piano in seguito?",
  "agency_faq_a5": "Assolutamente. Puoi passare da Starter a Performance o Premium in qualsiasi momento. Accrediteremo il tuo investimento iniziale.",
  "agency_cta_title_1": "Pronto a crescere ",
  "agency_cta_title_2": "senza limiti?",
  "agency_cta_subtitle": "Parlaci della tua attività e creeremo un piano personalizzato. Consulenza gratuita, senza impegno.",
  "agency_contact_name": "Il tuo nome",
  "agency_contact_email": "Indirizzo email",
  "agency_contact_biz_select": "Seleziona tipo di attività",
  "agency_contact_biz_restaurant": "Ristorante / Cibo",
  "agency_contact_biz_retail": "Commercio / Negozio",
  "agency_contact_biz_services": "Servizi professionali",
  "agency_contact_biz_fitness": "Fitness / Benessere",
  "agency_contact_biz_realestate": "Immobiliare",
  "agency_contact_biz_other": "Altro",
  "agency_contact_submit": "Consulenza gratuita",
  "agency_contact_sent_title": "Messaggio inviato!",
  "agency_contact_sent_desc": "Ti risponderemo entro 24 ore.",
  "agency_exit_title": "Aspetta! Audit velocità gratis?",
  "agency_exit_desc": "Scopri quanto più veloce potrebbe essere il tuo sito. Report dettagliato — 100% gratis.",
  "agency_exit_email": "La tua email",
  "agency_exit_submit": "Invia audit",
  "agency_exit_thanks_title": "Grazie!",
  "agency_exit_thanks_desc": "Ti invieremo l'audit gratuito entro 24 ore.",
  "agency_footer_brand_desc": "Sviluppato, ospitato e progettato da Infinitybusiness.org",
  "agency_footer_services": "Servizi",
  "agency_footer_fast_web": "Siti web veloci",
  "agency_footer_ecom": "Negozi E-Commerce",
  "agency_footer_seo": "Audit SEO",
  "agency_footer_ads": "Configurazione Google Ads",
  "agency_footer_maint": "Manutenzione",
  "agency_footer_company": "Azienda",
  "agency_footer_about": "Chi siamo",
  "agency_footer_contact": "Contatti",
  "agency_footer_privacy": "Privacy Policy",
  "agency_footer_terms": "Termini e Condizioni",
  "agency_footer_touch": "Contattaci",
  "agency_footer_copyright": "© 2026 Infinity Business. Tutti i diritti riservati.",
  "agency_footer_dev_by": "Sviluppato, ospitato e progettato da",
  "agency_footer_newsletter": "Iscriviti alla newsletter",
  "agency_footer_subscribe": "Iscriviti",
  "agency_sticky_pricing": "Vedi prezzi",
  "showroom_page_title": "Showroom",
  "showroom_meta_desc": "Esplora il nostro portfolio di trasformazioni web. Confronti prima e dopo di progetti reali dei clienti.",
  "showroom_badge": "I Nostri Lavori",
  "showroom_title_prefix": "Progetto",
  "showroom_title_highlight": "Showroom",
  "showroom_subtitle": "Guarda trasformazioni reali. Trascina il cursore per confrontare gli stati prima e dopo dei nostri progetti clienti.",
  "showroom_search_placeholder": "Cerca progetti...",
  "showroom_all_services": "Tutti i Servizi",
  "showroom_sort_newest": "Piu recenti",
  "showroom_sort_oldest": "Piu vecchi",
  "showroom_sort_name_az": "Nome A-Z",
  "showroom_sort_name_za": "Nome Z-A",
  "showroom_active_filters": "Filtri attivi",
  "showroom_showing": "Visualizzazione",
  "showroom_project_singular": "progetto",
  "showroom_project_plural": "progetti",
  "showroom_empty": "Nessun progetto nello showroom al momento.",
  "showroom_no_match": "Nessun progetto corrisponde ai tuoi filtri.",
  "showroom_features_built": "Funzionalita Realizzate",
  "showroom_visit_live": "Visita il Sito Live"
};
